/**
 * LAMPENWERK24 Cart Drawer v27 — Funnel-Properties Render
 * Changelog vs. v26:
 * - NEU: renderItems() rendert jetzt Funnel-Properties (Form, Logo-Datei,
 *   Logo-Vorschau usw.) als Amber-Badges/Pills unter dem Produkt-Titel.
 *   Properties mit `_`-Prefix werden ignoriert (Admin-only).
 *   URLs (https://, cloudinary) werden als klickbarer "Ansehen"-Link gerendert.
 * - Alles andere identisch zu v26.
 *
 * Round 24.6 (14.07.2026): Round 24.5 hatte die Fill-Kurve auf 50/68/80/90/100
 * angehoben, weil eine kleinere Kurve "nicht ausgefuellt" aussah. Max hat das
 * korrigiert: die Bar soll ECHTES Segment-Verhalten zeigen — 4 gleich breite
 * Segmente (25% je Meilenstein-Dot), bei 1 Lampe ist das halbe ERSTE Segment
 * voll (12.5% der Gesamt-Bar), jede weitere Lampenzahl (2/3/4/5) trifft exakt
 * einen Dot. Zurueck auf die urspruengliche, mathematisch korrekte Kurve
 * (12.5/25/50/75/100) — synchron zu snippets/lw-cart-drawer.liquid. Der
 * eigentliche Grund, warum das vorher "leer" aussah, war NIE die Prozentzahl,
 * sondern zu wenig Kontrast zwischen Fill- und Track-Farbe (siehe CSS-Fix im
 * Liquid-Snippet, .lw-prog-track ist jetzt ein dunkles Rille-Overlay statt
 * hell-auf-hell). Wenn die Kurve nochmal angepasst wird, IMMER in BEIDEN
 * Dateien gleichzeitig aendern.
 */
(function(){
  'use strict';
  var SURCHS=[53955374088532,53957538677076];
  /* Kein FREE_SHIP-Preislimit mehr: die alte Konstante (7100 = 71 EUR) bildete eine
     Grenze ab, die es im Lieferprofil nie gab. Versand haengt am Gewicht, siehe
     getShipping() weiter unten. Nicht wieder einfuehren. */
  /* Stufen am 10.09.2026 am Live-Warenkorb nachgemessen (Rezept im Kopf von
     snippets/lw-bundle-tier-logic.liquid). */
  var MS=[
    {qty:2,pct:25, label:'2× −10%',  short:'−10%'},
    {qty:3,pct:50, label:'3× −15%',  short:'−15%'},
    {qty:4,pct:75, label:'4× −25%',  short:'−25%'},
    {qty:5,pct:100,label:'5× −28%',  short:'−28%'}
  ];
  var cart=null,busy=false;
  function qs(s){return document.querySelector(s);}
  function qa(s){return Array.prototype.slice.call(document.querySelectorAll(s));}
  function fmt(c){return(c/100).toFixed(2).replace('.',',')+' €';}
  function isS(i){return SURCHS.indexOf(i.variant_id)!==-1;}
  /* Sale-/WM-Artikel (Property _reg gesetzt) sind aus dem Mengenrabatt-Scope raus →
     zählen NICHT fürs Bundle (sonst würde der Kunde Staffel auf den schon gesenkten Preis erwarten). */
  /* ⚠️ ZUBEHOER IST KEINE LAMPE (13.08.2026, Preis-Audit).
     Bis heute zaehlte jede Warenkorbzeile als Lampe, die keine
     Surcharge-Variante und kein Sale-Artikel war. Ein LED-Streifen fuer
     10,00 EUR machte damit aus einer Lampe ein "Bundle" und der Drawer
     meldete "-10% aktiv" - Shopify gab 0,00 EUR Rabatt, weil der Streifen
     nicht in der Kollektion "alle-lampen" liegt. Die Liste dazu steht in
     snippets/lw-zubehoer-liste.liquid und wird von Liquid und JS gelesen.
     Faellt sie aus (Snippet nicht gerendert), bleibt es beim alten
     Verhalten - lieber die alte Zaehlung als eine Ausnahme, die still
     alles ausschliesst. */
  function istZubehoer(i){
    return typeof window.LW_IST_ZUBEHOER === 'function' ? !!window.LW_IST_ZUBEHOER(i) : false;
  }
  function isExcl(i){return isS(i)||istZubehoer(i)||!!(i&&i.properties&&i.properties._reg);}
  function esc(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML;}
  /* ⚠️ esc() SCHUETZT TEXTKNOTEN, NICHT ATTRIBUTE (07.09.2026).
     Es setzt textContent und liest innerHTML zurueck. Diese Serialisierung
     maskiert &, < und >, aber KEIN Anfuehrungszeichen - das braucht sie im
     Textknoten auch nicht. In einem doppelt gequoteten Attribut bricht ein
     " damit aus dem Attribut aus.
     Das ist hier kein theoretischer Fall: die Werte kommen aus den
     Warenkorb-Eigenschaften (Wunschtext, Ortsname, Motiv), also aus einem
     Feld, in das der Kunde selbst tippt, und sie landen unter anderem in
     alt, title und href. escAttr() setzt auf esc() auf und nimmt die beiden
     Anfuehrungszeichen dazu. Wer eine neue Zeile mit einem Attribut baut,
     nimmt escAttr, im Text bleibt esc. */
  function escAttr(s){return esc(s).replace(/"/g,'&quot;').replace(/'/g,'&#39;');}
  function szUrl(u,s){if(!u)return'';var m=u.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?/i);if(m){var p=u.split(m[0]);return p[0]+'_'+s+'.'+m[1]+(m[2]||'');}return u;}
  function getElig(){if(!cart)return 0;var t=0;for(var i=0;i<cart.items.length;i++){if(!isExcl(cart.items[i]))t+=cart.items[i].final_line_price;}return t;}
  function getEligOrig(){if(!cart)return 0;var t=0;for(var i=0;i<cart.items.length;i++){if(!isExcl(cart.items[i]))t+=(cart.items[i].original_line_price||cart.items[i].final_line_price);}return t;}
  function getWarenwert(){if(!cart)return 0;var t=0;for(var i=0;i<cart.items.length;i++){var it=cart.items[i];var orig=it.original_line_price||it.final_line_price;var reg=(it.properties&&it.properties._reg)?parseInt(it.properties._reg,10)*(it.quantity||1):0;t+=(reg>orig?reg:orig);}return t;}
  /* Lampenzahl fuer Abzeichen und Staffel: Aufpreiszeilen, Zubehoer und
     Sale-Artikel zaehlen nicht.
     ⚠️ DAS IST NICHT DIE ZAHL FUER DEN SCHUBFACHKOPF. Der sagt "Artikel" und
     meint alles im Korb ohne die Aufpreiszeilen; ein Korb mit nur einem
     LED-Streifen stuende hier auf 0. Den Kopf schreibt der Counter-Sync in
     snippets/lw-cart-drawer.liquid, und zwar als einziger. Am 07.09.2026
     habe ich renderCount() zusaetzlich darauf schreiben lassen - das gab zwei
     Schreiber mit zwei Regeln auf einem Knoten. Nicht wiederholen. */
  function getLampCount(){
    if(!cart)return 0;
    var n=0;
    for(var i=0;i<cart.items.length;i++){
      if(!isS(cart.items[i])&&!istZubehoer(cart.items[i])) n+=cart.items[i].quantity||0;
    }
    return n;
  }
  /* Bundle-berechtigte Lampen: Surcharge UND Sale-Artikel (_reg) zählen NICHT. */
  function getBundleCount(){if(!cart)return 0;var n=0;for(var i=0;i<cart.items.length;i++){if(!isExcl(cart.items[i]))n+=cart.items[i].quantity||0;}return n;}
  /* ⚠️ HIER STANDEN collectDiscounts() UND renderAllDiscounts(), ZUSAMMEN 45
     ZEILEN (geloescht am 09.09.2026). Sie haben die Abzuege in drei Sorten
     zerlegt - Sale-Rabatt aus _reg, Mengenrabatt auf der Zeile, Rabattcode
     auf Korbebene - und je eine rote Zeile in den Fuss gehaengt.

     Der Fuss zeigt seit Max' Wahl von Entwurf C keine Rabattposten mehr,
     sondern den Abzug als Differenz zweier Preise in der Gesamtzeile. Damit
     hat die Aufteilung keinen Ort mehr, an dem sie ankommt, und die Frage
     "gibt es ueberhaupt einen Abzug" beantwortet renderFooter() mit
     wert > cart.total_price in einer Zeile.

     ⚠️ WER DIE POSTEN ZURUECKHOLT, HOLT AUCH IHRE STOLPERSTELLEN ZURUECK:
     die Zeilen wurden bei jedem Rendern neu erzeugt und wieder entfernt
     (.lw-dyn-disc), sie haengten sich per #lw-subtotal-val an ein Element,
     das es nicht mehr gibt, und zwei von ihnen standen als leere Huelsen
     schon im Markup (#lw-disc-row, #lw-bundle-disc-row), damit die dritte
     einen Anker hatte.
     Aufraeumen heisst loeschen, nicht auskommentieren (CLAUDE.md). */
  /* FREE-SHIP-SALE-Flag: gesetzt vom Sale-Banner (window.LW_FREESHIP_SALE bzw.
     [data-lw-freeship] im DOM). Live ausgelesen (nicht gecacht), damit es egal ist
     ob Banner-Script vor oder nach diesem Asset lädt. Banner an = Versand geschenkt. */
  function freeShipSale(){
    return (typeof window!=='undefined' && window.LW_FREESHIP_SALE===true)
      || !!document.querySelector('[data-lw-freeship]');
  }
  /* Versand gewichtsbasiert: jede Lampe wiegt 300g → ab 2 Lampen (600g) kostenlos.
     Entkoppelt vom Preis (kein 70,99€-Konflikt mehr bei Sale) und identisch zur Shopify-
     Versandregel (bis 0,599 kg = 4,90€, darüber frei). Surcharge-Zeilen wiegen 0g.
     Während der Free-Ship-Aktion immer 0 (Shopify-Gewichtsregel 0-300g steht dann auf 0€).
     Schwelle >=599 statt >=600, damit hier exakt dieselbe Zahl steht wie im Liquid
     (lw-cart-drawer.liquid, main-cart-footer/-items). Bei 300g-Varianten sind beide
     Werte gleichbedeutend — 599g ist gar nicht erreichbar —, aber zwei verschiedene
     Zahlen für dieselbe Anzeige laden dazu ein, dass sie später auseinanderlaufen. */
  function getShipping(){
    if(freeShipSale()) return 0;
    if(cart && (cart.total_weight||0) >= 599) return 0;
    return 490;
  }
  function stripSizeFromVariantTitle(vt, stripXL, stripOutdoor, stripAnschluss){
    if(!vt) return '';
    var out = vt;
    /* USB-C / USB-A ist seit dem 04.09.2026 die zweite Optionsachse; sie hat
       die tote Achse "Drinnen / Draußen" abgeloest. Der Wert steht schon als
       Badge in der Zeile, im Variantentitel waere er ein zweites Mal
       dasselbe. Bewusst mit optionalem Bindestrich gesucht, damit eine
       spaetere Schreibweise "USB C" nicht durchrutscht. */
    if(stripAnschluss){
      out = out
        .replace(/\s*\/\s*USB[-\s]?[AC]\s*/gi, ' / ')
        .replace(/^USB[-\s]?[AC]\s*$/gi, '');
    }
    if(stripXL){
      out = out
        .replace(/\s*\/\s*Premium\s*XL\s*32\s*cm\s*/gi, ' / ')
        .replace(/^Premium\s*XL\s*32\s*cm\s*$/gi, '')
        .replace(/\s*\/\s*Standard\s*22\s*cm\s*/gi, ' / ')
        .replace(/^Standard\s*22\s*cm\s*$/gi, '')
        .replace(/\s*\/\s*Maxi\s*42\s*cm\s*/gi, ' / ')
        .replace(/^Maxi\s*42\s*cm\s*$/gi, '')
        .replace(/\s*\/\s*Mega\s*52\s*cm\s*/gi, ' / ')
        .replace(/^Mega\s*52\s*cm\s*$/gi, '');
    }
    if(stripOutdoor){
      out = out
        .replace(/\s*\/\s*Draußen\s*/gi, ' / ')
        .replace(/^Draußen\s*$/gi, '')
        .replace(/\s*\/\s*Drinnen\s*/gi, ' / ')
        .replace(/^Drinnen\s*$/gi, '');
    }
    out = out.replace(/\s*\/\s*\/\s*/g, ' / ')
             .replace(/^\s*\/\s*/, '')
             .replace(/\s*\/\s*$/, '')
             .trim();
    return out;
  }
  function buildGroups(){
    if(!cart)return[];
    var mains=[],surchs=[];
    for(var i=0;i<cart.items.length;i++){
      if(isS(cart.items[i])) surchs.push(cart.items[i]);
      else mains.push(cart.items[i]);
    }
    var xlSurchRemaining = 0, outSurchRemaining = 0;
    var xlSurchLines = [], outSurchLines = [];
    for(var si=0;si<surchs.length;si++){
      var sq = surchs[si].quantity || 0;
      if(surchs[si].variant_id===53955374088532){ xlSurchRemaining += sq; xlSurchLines.push(surchs[si]); }
      else if(surchs[si].variant_id===53957538677076){ outSurchRemaining += sq; outSurchLines.push(surchs[si]); }
    }
    var out=[];
    for(var j=0;j<mains.length;j++){
      var main=mains[j];
      var mainQty = main.quantity || 1;
      var props=main.properties||{};
      var variantTitle=main.variant_title||'';
      var badges=[];
      var extraFinal=0, extraOrig=0;
      var stripXL=false, stripOutdoor=false;
      /* R16 (Max: "zeigt mir Premium XL einmal, ich weiss nicht was die andere
         Groesse ist") - Set-Produkte (z.B. Bahnuebergang+Andreaskreuz-Set) haben
         EINEN Variantentitel mit 3 Segmenten ("Ausfuehrung / Groesse Lampe1 /
         Groesse Lampe2"). Die Badge-Logik unten ist fuers normale Ein-Lampen-
         Sortiment gebaut: sie sucht IRGENDEIN Groessen-Keyword im ganzen String
         und zeigt nur DAS eine als Badge, strip() raeumt danach BEIDE Groessen-
         Erwaehnungen aus dem Titel (globales Regex) - Ausfuehrung UND die
         zweite Groesse gehen komplett verloren. Fix: bei 3+ Segmenten die
         Einzel-Lampen-Logik ueberspringen, kompletten Titel unangetastet zeigen. */
      var isCompoundSet = variantTitle.split(' / ').length >= 3;
      if (isCompoundSet) {
        var displayVTSet = variantTitle;
        var lineTotalSet = main.final_line_price;
        var origTotalSet = main.original_line_price || main.final_line_price;
        var lwRegSet = (main.properties && main.properties._reg) ? parseInt(main.properties._reg, 10) : 0;
        var lwUnitFinalSet = main.final_line_price / (main.quantity || 1);
        if (lwRegSet > 0 && lwRegSet > lwUnitFinalSet) {
          var lwRegTotalSet = lwRegSet * (main.quantity || 1);
          if (lwRegTotalSet > origTotalSet) origTotalSet = lwRegTotalSet;
        }
        /* R18 (Max: "ich weiss nicht was Premium XL ist, was ist die andere
           Groesse - bau 2 Zeilen: Zeile 1 Produkt 1 + Groesse, Zeile 2
           Produkt 2 + Groesse"). ROOT CAUSE des R17-"zeigt gar nichts"-Bugs:
           g.vt wurde korrekt mit dem vollen Titel befuellt, aber renderItems()
           gibt g.vt an KEINER Stelle im HTML aus (nur dispTitle+Badges+Perso+
           Wunschtext, siehe dortiger Diff) - deshalb zeigte der Drawer fuers
           Set NICHTS ausser dem nackten Produktnamen an, badges ist fuer
           Compound-Sets bewusst leer (b:[]). Fix: eigenes 2-Zeilen-Markup
           (setHtml), das renderItems jetzt tatsaechlich rendert. Produktnamen
           generisch aus dem "X + Y Set"-Produkttitel abgeleitet (nicht
           hartcodiert "Andreaskreuz"), damit kuenftige 2er-Sets automatisch
           funktionieren, ohne Code hier anzufassen. */
        /* ⚠️ DIE ZEILEN WURDEN UEBER DIE POSITION IM VARIANTENTITEL GEBAUT,
           UND SEIT DEM 07.09.2026 STIMMTE DIE POSITION NICHT MEHR.
           Jedes Duo-Set traegt seitdem genau drei Achsen: "Zweite Lampe"
           (beim Andreaskreuz-Set "Bahnlampe"), "Groesse" und "Anschluss".
           Das dritte Segment ist also USB-C oder USB-A. Es stand hier
           trotzdem hinter dem Namen der zweiten Lampe, im Warenkorb las
           sich das Check-Engine-Set als "Oelkanne: USB-C".

           Shopify liefert die Achsennamen in /cart.js mit, je Zeile als
           m.options_with_values. Sie werden jetzt von dort genommen, statt
           sie aus dem Produkttitel zu raten.

           ⚠️ ALLE ACHSEN, AUCH DER ANSCHLUSS. Hier stand kurz ein
           `if (/anschluss/i.test(soName)) continue;` mit der Begruendung,
           die Achse stehe ja schon als Badge daneben. Fuer eine normale
           Lampe stimmt das, fuer ein SET nicht: die Set-Zeile wird eine
           Zeile weiter unten mit `b:[]` gebaut, also ganz ohne Badges. Ein
           Duo-Set in M mit USB-A haette damit nirgends mehr gezeigt,
           welchen Anschluss der Kunde gekauft hat - und das sind 10 EUR
           Unterschied.
           ⚠️ Das ist zugleich der Grund, warum kuenftige Trios ohne
           Handgriff funktionieren: sie haben andere Achsen, und die Namen
           kommen aus dem Katalog. */
        var setHtml = '';
        var setOpts = main.options_with_values || [];
        for (var so = 0; so < setOpts.length; so++) {
          var soName = String(setOpts[so].name || '');
          var soWert = String(setOpts[so].value || '');
          if (!soName || !soWert) continue;
          setHtml += '<div style="font:600 12px/1.45 Inter,sans-serif;color:var(--ink-2)">'
                   + esc(soName) + ': <span style="color:var(--ink);font-weight:700">'
                   + esc(soWert) + '</span></div>';
        }
        /* Rueckfall fuer den Fall, dass options_with_values fehlt: dann
           lieber der nackte Variantentitel als eine falsche Zuordnung. */
        if (!setHtml && variantTitle) {
          setHtml = '<div style="font:600 12px/1.45 Inter,sans-serif;color:var(--ink-2)">'
                  + esc(variantTitle) + '</div>';
        }
        setHtml = setHtml ? '<div class="lw-iset" style="margin:3px 0 2px">' + setHtml + '</div>' : '';
        out.push({m:main,b:[],dp:lineTotalSet,origPrice:origTotalSet,vt:displayVTSet,setHtml:setHtml});
        continue;
      }
      var sizeFromPropsXL   = props['Größe'] && /premium|32/i.test(props['Größe']);
      var sizeFromVariantXL = /premium\s*xl|xl\s*32|32\s*cm/i.test(variantTitle);
      var hasXL = sizeFromPropsXL || sizeFromVariantXL;
      if(hasXL){
        if(sizeFromPropsXL){
          var claim = Math.min(mainQty, xlSurchRemaining);
          if(claim > 0){
            var perUnitFinal = xlSurchLines[0] ? (xlSurchLines[0].final_line_price / (xlSurchLines[0].quantity || 1)) : 1500;
            var perUnitOrig  = xlSurchLines[0] ? ((xlSurchLines[0].original_line_price||xlSurchLines[0].final_line_price) / (xlSurchLines[0].quantity || 1)) : 1500;
            extraFinal += Math.round(perUnitFinal * claim);
            extraOrig  += Math.round(perUnitOrig  * claim);
            xlSurchRemaining -= claim;
            badges.push({l:'L 32 cm',p:1500,native:false});
          } else {
            badges.push({l:'L 32 cm',native:true});
          }
        } else {
          badges.push({l:'L 32 cm',native:true});
        }
        stripXL=true;
      } else {
        /* ⚠️ DAS BADGE LOG BIS ZUM 07.09.2026 BEI DREI VON VIER GROESSEN.
           Hier stand eine Kette von Regexen ueber den ganzen Variantentitel,
           und die letzte lautete /32\s*cm|premium|xl/i. Seit die 900
           umgestellten Produkte ihre Groessen schlicht M / L / XL / XXL
           nennen, traf sie damit:
             "XL / USB-A"   -> "L 32 cm"       (xl steckt in XL)
             "XXL / USB-A"  -> "L 32 cm"       (xl steckt auch in XXL)
             "L / USB-C"    -> "Standard 22cm" (nichts traf, Rueckfall)
           Nur M war richtig. Im Warenkorb stand also bei einer 52-cm-Lampe
           "L 32 cm".

           Die richtige Aufloesung gibt es im Theme schon, in der Kaufspalte
           (snippets/lw-pdp-standard-v7.liquid, ab "Optionswerte schlicht
           M / L / XL / XXL"): erst der EXAKTE Optionswert zwischen Pipes
           gesucht, damit "XL" nicht auch "XXL" trifft, dann der alte
           cm-Name. Beides nebeneinander, weil die Funnel-Produkte weiter
           'Standard 22cm' / 'Premium XL 32cm' / 'Maxi 42cm' / 'Mega 52cm'
           heissen. Dieselbe Reihenfolge, dieselben Zahlen: M 22, L 32,
           XL 42, XXL 52. */
        var vo='|'+String(variantTitle||'').split(' / ').join('|')+'|';
        var sizeLbl='';
        if(vo.indexOf('|M|')!==-1) sizeLbl='M 22 cm';
        else if(vo.indexOf('|L|')!==-1) sizeLbl='L 32 cm';
        else if(vo.indexOf('|XL|')!==-1) sizeLbl='XL 42 cm';
        else if(vo.indexOf('|XXL|')!==-1) sizeLbl='XXL 52 cm';
        else if(/52\s*cm|mega/i.test(variantTitle)) sizeLbl='XXL 52 cm';
        else if(/42\s*cm|maxi/i.test(variantTitle)) sizeLbl='XL 42 cm';
        else if(/32\s*cm|premium/i.test(variantTitle)) sizeLbl='L 32 cm';
        else sizeLbl='M 22 cm';
        badges.push({l:sizeLbl,native:true});
        stripXL=true;
      }
      /* ── ANSCHLUSS ─────────────────────────────────────────────────────
         Nur die Abweichung ist eine Information wert: USB-A bekommt ein
         Badge, USB-C bleibt unbeschriftet. Truege jede Zeile ein Etikett,
         unterschiede es nichts mehr - dieselbe Ueberlegung wie bei der
         Groesse, wo "Standard 22cm" ebenfalls nur als Badge und nicht
         zusaetzlich im Titel steht. */
      var stripAnschluss = false;
      if(/usb[-\s]?a/i.test(variantTitle)){
        badges.push({l:'USB-A',native:true});
        stripAnschluss = true;
      } else if(/usb[-\s]?c/i.test(variantTitle)){
        /* 23.10.2026, Max: «Im Warenkorb bitte auch immer hinschreiben: USB-A oder USB-C.»
           Die Begruendung oben (nur die Abweichung beschriften) gilt damit nicht mehr. */
        badges.push({l:'USB-C',native:true});
        stripAnschluss = true;
      }

      var useFromProps   = props['Verwendung'] && /drau/i.test(props['Verwendung']);
      var useFromVariant = /drau|outdoor/i.test(variantTitle);
      if(useFromProps){
        var claim2 = Math.min(mainQty, outSurchRemaining);
        if(claim2 > 0){
          var perUnitFinal2 = outSurchLines[0] ? (outSurchLines[0].final_line_price / (outSurchLines[0].quantity || 1)) : 1000;
          var perUnitOrig2  = outSurchLines[0] ? ((outSurchLines[0].original_line_price||outSurchLines[0].final_line_price) / (outSurchLines[0].quantity || 1)) : 1000;
          extraFinal += Math.round(perUnitFinal2 * claim2);
          extraOrig  += Math.round(perUnitOrig2  * claim2);
          outSurchRemaining -= claim2;
          badges.push({l:'Draußen',p:1000,native:false});
        } else {
          badges.push({l:'Draußen',native:true});
        }
        stripOutdoor=true;
      } else if(useFromVariant){
        badges.push({l:'Draußen',native:true});
        stripOutdoor=true;
      }
      var displayVT = stripSizeFromVariantTitle(variantTitle, stripXL, stripOutdoor, stripAnschluss);
      var lineTotal=main.final_line_price+extraFinal;
      var origTotal=(main.original_line_price||main.final_line_price)+extraOrig;
      /* LW24: Normalpreis-Strich aus Line-Item-Property _reg (Metafeld-Cents je Stück).
         Wenn Normalpreis > aktueller Stückpreis, origTotal hochsetzen → bestehende
         Strich-Render-Logik (origPrice>dp) zeigt automatisch den roten Strich. */
      var lwReg=(main.properties&&main.properties._reg)?parseInt(main.properties._reg,10):0;
      var lwUnitFinal=main.final_line_price/(main.quantity||1);
      if(lwReg>0&&lwReg>lwUnitFinal){
        var lwRegTotal=(lwReg*(main.quantity||1))+extraOrig;
        if(lwRegTotal>origTotal)origTotal=lwRegTotal;
      }
      out.push({m:main,b:badges,dp:lineTotal,origPrice:origTotal,vt:displayVT});
    }
    return out;
  }
  function cleanupOrphanSurcharges(){
    if(busy || !cart || !cart.items) return false;
    var mains=[], xlLines=[], outLines=[];
    for(var i=0;i<cart.items.length;i++){
      var it = cart.items[i];
      if(it.variant_id===53955374088532) xlLines.push(it);
      else if(it.variant_id===53957538677076) outLines.push(it);
      else mains.push(it);
    }
    var xlDemand=0, outDemand=0;
    for(var m=0;m<mains.length;m++){
      var props=mains[m].properties||{};
      var mq=mains[m].quantity||1;
      if(props['Größe'] && /premium/i.test(props['Größe'])) xlDemand+=mq;
      if(props['Verwendung'] && /drau/i.test(props['Verwendung'])) outDemand+=mq;
    }
    function supplySum(lines){ var s=0; for(var i=0;i<lines.length;i++) s+=lines[i].quantity||0; return s; }
    var xlSupply = supplySum(xlLines);
    var outSupply = supplySum(outLines);
    var updates={};
    var hasUpdate=false;
    function reduce(lines, overshoot){
      for(var i=0;i<lines.length && overshoot>0;i++){
        var lq = lines[i].quantity||0;
        var take = Math.min(lq, overshoot);
        updates[lines[i].key] = lq - take;
        overshoot -= take;
        hasUpdate=true;
      }
    }
    if(xlSupply > xlDemand)   reduce(xlLines,  xlSupply  - xlDemand);
    if(outSupply > outDemand) reduce(outLines, outSupply - outDemand);
    if(!hasUpdate) return false;
    busy=true;
    console.log('[LW Cart v27] Orphan-Surcharge-Cleanup:', updates);
    fetch('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({updates:updates}),
      credentials:'same-origin'
    })
    .then(function(){ return fetchCart(); })
    .then(function(){ busy=false; renderAll(); })
    .catch(function(){ busy=false; });
    return true;
  }
  function renderProgress(lampCount){
    /* Idempotenz-Guard gegen grün→aus→grün-Flackern: gleicher Stand → Bar NICHT neu
       schreiben (kein erneutes Width-Animieren / Klassen-Toggle beim Doppel-Render). */
    if(lampCount===_lastProgCount) return;
    _lastProgCount=lampCount;
    /* Keine bundle-berechtigten Lampen (reiner Sale-/WM-Warenkorb) → Bundle-Leiste ausblenden */
    var progSec=document.querySelector('.lw-prog');
    if(progSec)progSec.style.display=(lampCount<=0)?'none':'';
    var fill=qs('#lw-prog-fill'),hint=qs('#lw-prog-hint');
    if(!fill)return;
    var pct;
    /* Round 24.5: 1 Lampe jetzt 50% statt 12.5% (Max: "keine progress in der
       bar" — Round 24.6: das war nie das eigentliche Problem, siehe
       Datei-Kopfkommentar). 12.5 = halbes erstes Segment (0-25%). */
    if(lampCount<=0)pct=0;
    else if(lampCount===1)pct=12.5;
    else if(lampCount>=5)pct=100;
    else {
      var matched=null;
      for(var m=0;m<MS.length;m++){if(MS[m].qty===lampCount){matched=MS[m];break;}}
      pct=matched?matched.pct:100;
    }
    fill.style.width=Math.max(pct,lampCount>0?3:0)+'%';
    for(var i=0;i<MS.length;i++){
      var dot=qs('#lw-ms'+i),lbl=qs('#lw-msl'+i),reached=lampCount>=MS[i].qty;
      if(dot){if(reached)dot.classList.add('on');else dot.classList.remove('on');}
      if(lbl){if(reached)lbl.classList.add('on');else lbl.classList.remove('on');}
    }
    /* ⚠️ HIER STAND DER HINWEIS-ZWEIG, 13 ZEILEN IN EIN ELEMENT, DAS ES
       NICHT MEHR GIBT. #lw-prog-hint ist am 07.09.2026 aus dem Markup
       gefallen; es war doppelt auf display:none gesetzt und hat nie
       jemand gesehen. Mit ihm gefallen sind vier Rechenzeichen U+2212
       MINUS SIGN, die es nur hier gab. Die Aussage steht in der Kopfzeile
       der Motivationskarte und auf den Etiketten der Leiste. */
  }
  /* ═══════════════════════════════════════════════════════════
     v27: renderItems mit Funnel-Properties als Amber-Badges
     Properties mit '_'-Prefix werden ignoriert (Admin-only).
     URL-Werte werden als klickbarer "Ansehen"-Link gerendert.
     ═══════════════════════════════════════════════════════════ */
  var _lastItemsSig=null, _lastProgCount=null;
  function renderItems(groups){
    var c=qs('#lw-items');if(!c)return;
    /* Idempotenz-Guard: identischer Cart → DOM NICHT neu bauen (kein Bild-Flash beim
       Sicherheits-Refresh nach Add/Update). Existierende Buttons + Listener bleiben gültig. */
    var sig;
    try{sig=JSON.stringify((cart&&cart.items||[]).map(function(it){return [it.key,it.variant_id,it.quantity,it.line_price,it.properties];}));}catch(e){sig=null;}
    if(sig!==null && sig===_lastItemsSig) return;
    _lastItemsSig=sig;
    var html='';
    for(var i=0;i<groups.length;i++){
      var g=groups[i],m=g.m,b=g.b,dp=g.dp;
      var setHtml=g.setHtml||'';
      /* LW24 Schild-Waehler: Motiv-Vorschau (_vorschau) hat Vorrang vor (leerem) Archiv-Produktbild */
      var img=(m.properties&&m.properties._vorschau)?m.properties._vorschau:(m.featured_image&&m.featured_image.url?szUrl(m.featured_image.url,'200x'):'');
      var dispTitle=(m.properties&&m.properties.Motiv)?String(m.properties.Motiv):(m.product_title||'');
      /* LW24 Schild-Waehler: Wunschtext (Personalisierung) auch im Cart-Drawer zeigen */
      var wH=(m.properties&&m.properties['Wunschtext'])?'<div class="lw-iperso" style="font:600 12px/1.35 Inter,sans-serif;color:#0E1013;margin:5px 0 1px"><span style="color:var(--marke);font-weight:700">&#9998; </span>'+esc(m.properties['Wunschtext'])+'</div>':'';
      /* v37: Funnel-Item-Detection NUR über Hidden-Marker _Funnel-Session / _Funnel-Version.
         Diese werden ausschliesslich vom Funnel gesetzt - nicht von normalen PDP-Add-to-Carts.
         So bekommen Standard-Items (Haltestelle etc.) keine "Personalisierung"-Box.
         Backward-Compat: alte snake_case-Keys (_funnel_session_id / _funnel_version) als Fallback. */
      var isFunnelItem = !!(m.properties && (
        m.properties['_Funnel-Session'] ||
        m.properties['_Funnel-Version'] ||
        m.properties._funnel_session_id ||
        m.properties._funnel_version
      ));
      /* v38: Die Perso-PDPs (snippets/lw-perso-*.liquid) legen ohne Funnel in den
         Warenkorb und setzen dabei _Perso-Typ. Sie sind genauso personalisiert und
         bekommen dieselbe Box. Unterschied zum Funnel: die Groesse steckt bei ihnen
         in der Variante, nicht in den Properties - die Variantenzeile bleibt darum
         sichtbar (siehe naechste Zeile). */
      var isPersoItem = !!(m.properties && m.properties['_Perso-Typ']);
      var isConfigured = isFunnelItem || isPersoItem;
      /* `var v` stand hier, wurde befuellt und nie gelesen: der
         Variantentitel kommt weiter unten aus g.vt selbst. Geloescht am
         07.09.2026. */
      var bH='';
      if(b.length){
        bH='<div class="lw-ib">';
        for(var j=0;j<b.length;j++){
          var priceSuffix = b[j].native ? '' : ' <span class="lw-bgp">+'+fmt(b[j].p)+'</span>';
          bH+='<span class="lw-bg">'+esc(b[j].l)+priceSuffix+'</span>';
        }
        bH+='</div>';
      }
      /* v38: Properties nur fuer konfigurierte Artikel — Funnel (_Funnel-Session) oder
         Perso-PDP (_Perso-Typ). Standard-Items (Haltestelle etc.) bleiben aussen vor.
         Property-Label-Mapping fuer Backward-Compatibility (alte Carts mit "Logo-Datei"). */
      var pH='';
      if(isConfigured && m.properties){
        var pImg='';
        var pTextRows=[];
        /* Label-Mapping: alte Property-Namen werden im Display zu kurzen, kundenfreundlichen Labels */
        /* Round 25: Logo-Vorschau (= hochgeladene Datei) heisst im Drawer
           "Originaldatei" - klar abgegrenzt von der KI-Lampen-Vorschau. */
        var labelMap = {
          'Logo-Datei': 'Originaldatei',
          'Datei': 'Originaldatei',
          'Logo-Vorschau': 'Originaldatei'
        };
        /* HU-Funnel: Mini-Plakette als Inline-SVG generieren statt Image-Thumb.
           Triggert wenn _Funnel-Typ === 'hauptuntersuchung' UND Ziffer + _Plakettenfarbe-Hex vorhanden.
           Backward-Compat: alte snake_case-Keys (_funnel_type / _plakettenfarbe_hex) als Fallback.
           Schwarz-Invertierung: bei dunkler Plakettenfarbe werden alle "schwarzen" Druck-Elemente
           (Trennlinien, Wedge, Zahlen, Innen-Border, Ziffer) zu weiss - der Aussen-Ring nicht,
           der traegt die Plakettenfarbe. */
        var _ftEarly = m.properties['_Funnel-Typ'] || m.properties._funnel_type || '';
        if (_ftEarly === 'hauptuntersuchung') {
          var huZiffer = (m.properties.Ziffer || '').toString().slice(0, 2);
          var huFarbeHex = m.properties['_Plakettenfarbe-Hex'] || m.properties._plakettenfarbe_hex || '#f97316';
          /* Luminanz-basierte Tinten-Berechnung (gleiche Logik wie im Funnel) */
          var huInk = '#0e1013';
          var hxClean = String(huFarbeHex).replace('#', '');
          if (hxClean.length === 3) hxClean = hxClean[0]+hxClean[0]+hxClean[1]+hxClean[1]+hxClean[2]+hxClean[2];
          if (hxClean.length === 6) {
            var hxR = parseInt(hxClean.substr(0,2),16);
            var hxG = parseInt(hxClean.substr(2,2),16);
            var hxB = parseInt(hxClean.substr(4,2),16);
            if (!isNaN(hxR) && !isNaN(hxG) && !isNaN(hxB)) {
              var hxLuma = 0.299*hxR + 0.587*hxG + 0.114*hxB;
              if (hxLuma < 75) huInk = '#ffffff';
            }
          }
          var huFontSize = huZiffer.length <= 1 ? 56 : 42;
          /* Compact SVG (viewBox 320x320 - identisch zur Funnel-Preview, skaliert via CSS auf 82px)
             WICHTIG: Der Aussen-Ring traegt immer die Plakettenfarbe (Scheibe bis zum Rand
             durchgefaerbt). Die "Druck-Tinte" (Trennlinien, Wedge, Zahlen aussen, Innen-Border
             r=42, Mittel-Ziffer) wird invertiert - 1:1 wie in der PDP-Vorschau. */
          var huSvg = ''
            + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" class="lw-cart-prop__hu-svg" aria-label="HU-Plakette mit Ziffer ' + escAttr(huZiffer) + '">'
            + '<circle cx="160" cy="160" r="155" fill="' + escAttr(huFarbeHex) + '"/>'
            + '<circle cx="160" cy="160" r="142" fill="' + escAttr(huFarbeHex) + '"/>'
            + '<g stroke="' + escAttr(huInk) + '" stroke-width="4">'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(15 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(45 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(75 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(105 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(135 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(165 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(195 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(225 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(255 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(285 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(315 160 160)"/>'
            +   '<line x1="160" y1="60" x2="160" y2="142" transform="rotate(345 160 160)"/>'
            + '</g>'
            + '<path d="M 160 60 L 145 19 A 142 142 0 0 1 175 19 Z" fill="' + escAttr(huInk) + '"/>'
            + '<g font-family="Futura, Jost, Trebuchet MS, sans-serif" font-weight="800" font-size="20" text-anchor="middle" fill="' + escAttr(huInk) + '">'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(0 160 160)">12</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(30 160 160)">1</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(60 160 160)">2</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(90 160 160)">3</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(120 160 160)">4</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(150 160 160)">5</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(180 160 160)">6</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(210 160 160)">7</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(240 160 160)">8</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(270 160 160)">9</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(300 160 160)">10</text>'
            +   '<text x="160" y="68" dy="0.35em" transform="rotate(330 160 160)">11</text>'
            + '</g>'
            + '<circle cx="160" cy="160" r="42" fill="' + escAttr(huInk) + '"/>'
            + '<circle cx="160" cy="160" r="38" fill="' + escAttr(huFarbeHex) + '"/>'
            + '<text x="160" y="160" dy="0.35em" fill="' + escAttr(huInk) + '" font-family="Futura, Jost, Trebuchet MS, sans-serif" font-weight="900" font-size="' + huFontSize + '" text-anchor="middle">' + esc(huZiffer || '25') + '</text>'
            + '</svg>';
          pImg = '<div class="lw-cart-prop__thumb lw-cart-prop__thumb--hu" aria-hidden="true">' + huSvg + '</div>';
        }
        /* Ortstafel-Funnel: Mini-Schild als Inline-SVG. Triggert wenn _Funnel-Typ
           in [ortstafel-eingang, ortstafel-ausgang] UND NICHT Image-Modus.
           Image-Modus (_Image-Modus=true) faellt auf das normale Image-Detection durch
           und zeigt das hochgeladene Referenzbild als Thumb.
           Eingang + Ausgang haben UNTERSCHIEDLICHE Layouts (1 Schild vs 2 gestapelte Schilder).
           Backward-Compat: _funnel_type / _image_only als Fallback. */
        var otFunnelType = m.properties['_Funnel-Typ'] || m.properties._funnel_type || '';
        var otIsImageOnly = (m.properties['_Image-Modus'] || m.properties._image_only) === 'true';
        /* === ORTSTAFEL-EINGANG: 1 Schild mit 1-4 Zeilen Text === */
        if (otFunnelType === 'ortstafel-eingang' && !otIsImageOnly) {
          /* Zeilen + Breiten aus Properties einsammeln (mit Backward-Compat) */
          var otLineCount = parseInt(m.properties['_Zeilen-Anzahl'] || m.properties._zeilen_count || '2', 10) || 2;
          if (otLineCount < 1) otLineCount = 1;
          if (otLineCount > 4) otLineCount = 4;
          var otLines = [];
          for (var li = 1; li <= otLineCount; li++) {
            var lt = (m.properties['Zeile ' + li] || '').toString().trim();
            if (lt) otLines.push(lt);
          }
          /* Falls keine Zeilen drin sind: skippen, fallback auf Standard-Image */
          if (otLines.length > 0) {
            var otWidthsStr = (m.properties['_Zeilen-Breiten'] || m.properties._zeilen_breiten || '100,100,100,100').toString();
            var otWidthsArr = otWidthsStr.split(',').map(function(x){ return parseInt(x, 10) || 100; });
            /* Aspect-Ratio passend zur Zeilenanzahl - matcht den Funnel */
            var otAspect = ({ 1: 1.7, 2: 1.5, 3: 1.4, 4: 1.35 })[otLines.length] || 1.5;
            var otVbW = 320;
            var otVbH = Math.round(otVbW / otAspect);
            var otBaseByCount = { 1: 90, 2: 72, 3: 58, 4: 48 };
            var otBaseFont = otBaseByCount[otLines.length] || 60;
            var otAvailableWidth = otVbW - 36;
            var otMaxFont = otBaseFont;
            for (var fi = 0; fi < otLines.length; fi++) {
              var line = otLines[fi];
              var widthFactor = (otWidthsArr[fi] || 100) / 100;
              var lineMaxWidth = otAvailableWidth * widthFactor;
              if (line.length > 0) {
                var fitFont = Math.floor(lineMaxWidth / (line.length * 0.5));
                if (fitFont < otMaxFont) otMaxFont = fitFont;
              }
            }
            if (otMaxFont < 12) otMaxFont = 12;
            var otLineH = otMaxFont * 1.18;
            var otTotalH = otLines.length * otLineH;
            var otStartY = (otVbH - otTotalH) / 2 + (otMaxFont * 0.85);
            var otSvg = ''
              + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + otVbW + ' ' + otVbH + '" class="lw-cart-prop__ot-svg" aria-label="Ortstafel-Vorschau">'
              + '<rect x="3" y="3" width="' + (otVbW - 6) + '" height="' + (otVbH - 6) + '" rx="14" ry="14" fill="#0e1013"/>'
              + '<rect x="13" y="13" width="' + (otVbW - 26) + '" height="' + (otVbH - 26) + '" rx="8" ry="8" fill="#fcd116"/>'
              + '<rect x="20" y="20" width="' + (otVbW - 40) + '" height="' + (otVbH - 40) + '" rx="4" ry="4" fill="none" stroke="#0e1013" stroke-width="3"/>';
            for (var ti = 0; ti < otLines.length; ti++) {
              var ty = otStartY + (ti * otLineH);
              otSvg += '<text x="' + (otVbW / 2) + '" y="' + ty + '" fill="#0e1013" font-family="PT Sans Narrow, Arial Narrow, Arial, sans-serif" font-weight="700" font-size="' + otMaxFont + '" text-anchor="middle">' + esc(otLines[ti]) + '</text>';
            }
            otSvg += '</svg>';
            pImg = '<div class="lw-cart-prop__thumb lw-cart-prop__thumb--ot" aria-hidden="true">' + otSvg + '</div>';
          }
        }
        /* === ORTSTAFEL-AUSGANG: 2 gestapelte Schilder (oben mit Pfeil + km, unten durchgestrichen) ===
           Properties: "Stadt oben", "Entfernung" (z.B. "3 km"), "Stadt unten"
           Hidden-Backup: _stadt_oben, _distanz_km, _stadt_unten */
        if (otFunnelType === 'ortstafel-ausgang' && !otIsImageOnly) {
          var oaStadtOben = (m.properties['Stadt oben'] || m.properties._stadt_oben || '').toString().trim();
          var oaDistRaw = (m.properties['Entfernung'] || m.properties._distanz_km || '').toString().trim();
          var oaStadtUnten = (m.properties['Stadt unten'] || m.properties._stadt_unten || '').toString().trim();
          // Distanz: nur Zahl extrahieren (Property koennte "3 km" oder "3" sein)
          var oaDistMatch = oaDistRaw.match(/(\d+)/);
          var oaDistNum = oaDistMatch ? oaDistMatch[1] : '';
          var oaDistLabel = oaDistNum ? (oaDistNum + ' km') : '';
          if (oaStadtOben && oaStadtUnten) {
            // viewBox 320x270 (Aspect ~1.18) - kompakte Mini-Variante des Funnel-SVGs
            var oaVbW = 320;
            var oaVbH = 270;
            // Helper: Auto-Fit Font-Size basierend auf char-count + max-width
            // Approx-Char-Breite PT Sans Narrow ~ 0.48 * fontSize
            function oaFitFont(text, maxW, baseFont, minFont) {
              if (!text) return baseFont;
              var fit = Math.floor(maxW / (text.length * 0.48));
              if (fit > baseFont) return baseFont;
              if (fit < minFont) return minFont;
              return fit;
            }
            // OBEN: Stadtname linksbuendig - kurze Namen wie "Berlin" werden gross (bis 64px), lange schrumpfen
            var oaObenFont = oaFitFont(oaStadtOben, 245, 64, 12);
            var oaDistFont = oaFitFont(oaDistLabel, 220, 28, 10);
            // UNTEN: Stadtname zentriert - kurze Namen wie "Berlin" gross (bis 72px), lange schrumpfen
            var oaUntenFont = oaFitFont(oaStadtUnten, 270, 72, 12);
            var oaSvg = ''
              + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + oaVbW + ' ' + oaVbH + '" class="lw-cart-prop__ot-svg lw-cart-prop__ot-svg--aus" aria-label="Ortsausgang-Vorschau">'
              // Aussen-Rahmen schwarz (Lampen-Optik)
              + '<rect x="3" y="3" width="' + (oaVbW - 6) + '" height="' + (oaVbH - 6) + '" rx="12" ry="12" fill="#0e1013"/>'
              // Oberes Schild (gelb)
              + '<rect x="13" y="13" width="' + (oaVbW - 26) + '" height="118" rx="6" ry="6" fill="#fcd116"/>'
              + '<rect x="19" y="19" width="' + (oaVbW - 38) + '" height="106" rx="3" ry="3" fill="none" stroke="#0e1013" stroke-width="2.5"/>'
              // Stadtname OBEN (linksbuendig - dy=0.35em fuer browser-stabiles vertikales Centering)
              + '<text x="30" y="55" dy="0.35em" fill="#0e1013" font-family="PT Sans Narrow, Arial Narrow, Arial, sans-serif" font-weight="700" font-size="' + oaObenFont + '" text-anchor="start">' + esc(oaStadtOben) + '</text>'
              // Pfeil (rechts oben)
              + '<g transform="translate(278, 42)" fill="#0e1013">'
              +   '<rect x="-3" y="2" width="6" height="28"/>'
              +   '<polygon points="-11,8 0,-7 11,8"/>'
              + '</g>'
              // Distanz (mittig drunter)
              + (oaDistLabel ? '<text x="160" y="103" dy="0.35em" fill="#0e1013" font-family="PT Sans Narrow, Arial Narrow, Arial, sans-serif" font-weight="700" font-size="' + oaDistFont + '" text-anchor="middle">' + esc(oaDistLabel) + '</text>' : '')
              // Trennstrich
              + '<rect x="13" y="133" width="' + (oaVbW - 26) + '" height="3" fill="#0e1013"/>'
              // Unteres Schild (gelb)
              + '<rect x="13" y="138" width="' + (oaVbW - 26) + '" height="119" rx="6" ry="6" fill="#fcd116"/>'
              + '<rect x="19" y="144" width="' + (oaVbW - 38) + '" height="107" rx="3" ry="3" fill="none" stroke="#0e1013" stroke-width="2.5"/>'
              // Roter Diagonal-Strich ZUERST (liegt im Hintergrund) - KEINE weisse Outline
              + '<line x1="28" y1="244" x2="292" y2="151" stroke="#dc2626" stroke-width="13" stroke-linecap="butt"/>'
              // Stadtname UNTEN ZULETZT (vor dem roten Strich) - dy=0.35em fuer sauberes vertikales Centering
              + '<text x="160" y="198" dy="0.35em" fill="#0e1013" font-family="PT Sans Narrow, Arial Narrow, Arial, sans-serif" font-weight="700" font-size="' + oaUntenFont + '" text-anchor="middle">' + esc(oaStadtUnten) + '</text>'
              + '</svg>';
            pImg = '<div class="lw-cart-prop__thumb lw-cart-prop__thumb--ot lw-cart-prop__thumb--ot-aus" aria-hidden="true">' + oaSvg + '</div>';
          }
        }
        /* === U-BAHN-FUNNEL: Quadratisches Schild mit grossem "U" + Stationsname ===
           Properties: "Stationsname", "Linie" (sichtbar) + hidden _Linien-Farbe / _Linien-Code.
           Backward-Compat: alter snake_case _farbe_hex / _stationsname als Fallback.
           Schwarz-Invertierung: bei hellen Hintergrundfarben (Gelb U4, Weiss) wird die Tinte
           (U + Stationsname) zu schwarz statt weiss - gleiche Logik wie HU. */
        if (otFunnelType === 'u-bahn') {
          var ubStation = (m.properties['Stationsname'] || m.properties._stationsname || '').toString().trim();
          var ubFarbeHex = m.properties['_Linien-Farbe'] || m.properties._farbe_hex || '#003a7c';
          if (ubStation) {
            // Luminanz-basierte Tinten-Berechnung
            var ubInk = '#ffffff';
            var ubHx = String(ubFarbeHex).replace('#', '');
            if (ubHx.length === 3) ubHx = ubHx[0]+ubHx[0]+ubHx[1]+ubHx[1]+ubHx[2]+ubHx[2];
            if (ubHx.length === 6) {
              var ubR = parseInt(ubHx.substr(0,2),16);
              var ubG = parseInt(ubHx.substr(2,2),16);
              var ubB = parseInt(ubHx.substr(4,2),16);
              if (!isNaN(ubR) && !isNaN(ubG) && !isNaN(ubB)) {
                var ubLuma = 0.299*ubR + 0.587*ubG + 0.114*ubB;
                if (ubLuma >= 130) ubInk = '#0e1013';
              }
            }
            // Auto-Fit Stationsname (Approx-Char-Breite PT Sans Narrow ~ 0.50 * fontSize)
            function ubFitFont(text, maxW, baseFont, minFont) {
              if (!text) return baseFont;
              var fit = Math.floor(maxW / (text.length * 0.50));
              if (fit > baseFont) return baseFont;
              if (fit < minFont) return minFont;
              return fit;
            }
            var ubStationFont = ubFitFont(ubStation, 250, 32, 10);
            var ubSvg = ''
              + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" class="lw-cart-prop__ub-svg" aria-label="U-Bahn-Vorschau ' + escAttr(ubStation) + '">'
              // Aussen-Rahmen traegt die Linienfarbe (Schild bis zur Kante durchgefaerbt)
              + '<rect x="6" y="6" width="308" height="308" rx="14" ry="14" fill="' + escAttr(ubFarbeHex) + '"/>'
              // Farbiges Innenfeld
              + '<rect x="22" y="22" width="276" height="276" rx="6" ry="6" fill="' + escAttr(ubFarbeHex) + '"/>'
              // Grosses "U" mittig
              + '<text x="160" y="142" fill="' + escAttr(ubInk) + '" font-family="PT Sans Narrow, Helvetica Neue, Arial, sans-serif" font-weight="700" font-size="190" text-anchor="middle" dominant-baseline="middle">U</text>'
              // Stationsname klein darunter
              + '<text x="160" y="252" fill="' + escAttr(ubInk) + '" font-family="PT Sans Narrow, Helvetica Neue, Arial, sans-serif" font-weight="700" font-size="' + ubStationFont + '" text-anchor="middle" dominant-baseline="middle" letter-spacing="0.5">' + esc(ubStation) + '</text>'
              + '</svg>';
            pImg = '<div class="lw-cart-prop__thumb lw-cart-prop__thumb--ub" aria-hidden="true">' + ubSvg + '</div>';
          }
        }
        /* === KFZ-AUTO-FUNNEL: Rechteckiges Kennzeichen-Schild als Inline-SVG ===
           Properties: "Kennzeichen", "Plakette oben", "Plakette unten" (sichtbar) + hidden
           _Kennzeichen-Stadt/Buchstaben/Zahlen / _Plakette-Oben-Hex / _Plakette-Unten-Hex.
           Backward-Compat: alte snake_case Keys (_kennzeichen_full / _kennzeichen_stadt etc.) als Fallback.
           Schwarz-Invertierung der Plaketten-Innentexte bei dunklen Plakettenfarben. */
        if (otFunnelType === 'kennzeichen-auto') {
          /* Mini-SVG synchron zur Funnel-Live-Vorschau:
             viewBox 64 hoch, Border 4, PLAK_R 8, Y_OBEN 20, Y_UNTEN 44.
             Dynamic-Width basierend auf approx. Glyph-Width (FE-Schrift ~0.55em + 2px letter-spacing).
             Rendert ZUSAETZLICH zur Funnel-v1.3: E-Auto-Suffix " E" + Saison-Block rechts. */
          var kfzFull = (m.properties['Kennzeichen'] || m.properties._kennzeichen_full || '').toString().trim();
          var kfzModus = (m.properties['_Kennzeichen-Modus'] || m.properties._kennzeichen_modus || 'strukturiert').toString();
          var kfzIsFreitext = kfzModus === 'freitext';
          var kfzFreitext = (m.properties['_Kennzeichen-Freitext'] || m.properties._kennzeichen_freitext || '').toString().trim().toUpperCase();
          var kfzStadt = (m.properties['_Kennzeichen-Stadt'] || m.properties._kennzeichen_stadt || '').toString().trim().toUpperCase();
          var kfzBuchstaben = (m.properties['_Kennzeichen-Buchstaben'] || m.properties._kennzeichen_buchstaben || '').toString().trim().toUpperCase();
          var kfzZahlen = (m.properties['_Kennzeichen-Zahlen'] || m.properties._kennzeichen_zahlen || '').toString().trim();
          var kfzTuevJahr = (m.properties['_Plakette-Oben-Ziffer'] || m.properties._plakette_oben_tuev_jahr || '').toString().trim();
          var kfzTuevSichtbar = (m.properties['_Plakette-Oben-Ziffer-Sichtbar'] || 'true') !== 'false';
          var kfzObenHex = m.properties['_Plakette-Oben-Hex'] || m.properties._plakette_oben_hex || '#F1C40F';
          var kfzUntenHex = m.properties['_Plakette-Unten-Hex'] || m.properties._plakette_unten_hex || '#003a7c';
          var kfzEAuto = (m.properties['_E-Auto'] || 'false') === 'true';
          var kfzSaisonAktiv = (m.properties['_Saison-Aktiv'] || 'false') === 'true';
          var kfzSaisonVon = (m.properties['_Saison-Von'] || '').toString().trim();
          var kfzSaisonBis = (m.properties['_Saison-Bis'] || '').toString().trim();
          var kfzPlakObenZeigen = (m.properties['_Plakette-Oben-Sichtbar'] || 'true') !== 'false';
          var kfzPlakUntenZeigen = (m.properties['_Plakette-Unten-Sichtbar'] || 'true') !== 'false';
          // Strukturiert: falls Einzelfelder fehlen aber Full vorhanden -> splitten
          if (!kfzIsFreitext && (!kfzStadt || !kfzBuchstaben || !kfzZahlen) && kfzFull) {
            var kfzParts = kfzFull.split(/\s+/);
            kfzStadt = kfzStadt || (kfzParts[0] || '').toUpperCase();
            kfzBuchstaben = kfzBuchstaben || (kfzParts[1] || '').toUpperCase();
            kfzZahlen = kfzZahlen || (kfzParts[2] || '');
          }
          if (kfzIsFreitext && !kfzFreitext && kfzFull) kfzFreitext = kfzFull.toUpperCase();
          var hasContent = kfzIsFreitext ? !!kfzFreitext : (kfzStadt || kfzBuchstaben || kfzZahlen);
          if (hasContent) {
            // Luminanz-Tinte: dunkle Plak -> weisser Inhalt
            function kfzInk(hex) {
              var ink = '#0e1013';
              var hxx = String(hex || '').replace('#', '');
              if (hxx.length === 3) hxx = hxx[0]+hxx[0]+hxx[1]+hxx[1]+hxx[2]+hxx[2];
              if (hxx.length === 6) {
                var rr = parseInt(hxx.substr(0,2),16);
                var gg = parseInt(hxx.substr(2,2),16);
                var bb = parseInt(hxx.substr(4,2),16);
                if (!isNaN(rr) && !isNaN(gg) && !isNaN(bb)) {
                  var lm = 0.299*rr + 0.587*gg + 0.114*bb;
                  if (lm < 130) ink = '#ffffff';
                }
              }
              return ink;
            }
            var kfzObenInk = kfzInk(kfzObenHex);
            // Layout-Konstanten (synchron zur Funnel-Live-Vorschau LAYOUT, 60-Plate)
            var L = {
              H: 60, AREA_START: 42, FONT: 28,
              PLAK_R: 8, GAP_SP: 7, GAP_PB: 7, GAP_BZ: 10,
              GAP_BLOCK_SAISON: 3, SAISON_W: 22, SAISON_PADDING_RIGHT: 3,
              PADDING_RIGHT: 8, LETTER_SPACING: 2,
              Y_TEXT: 32, Y_OBEN: 18, Y_UNTEN: 42
            };
            // Approx. visuelle Glyph-Breite (FE-Schrift ~0.55em + Letter-Spacing pro Lücke)
            function approxW(text, fontSize) {
              if (!text) return 0;
              // FE-Schrift ist schmaler als Standard-Sans (Faktor 0.50 statt 0.55).
              // Verhindert overestimate -> kein riesiger Gap mehr zwischen Text-Ende und Saison-Block.
              return text.length * (fontSize * 0.50) + Math.max(0, text.length - 1) * L.LETTER_SPACING;
            }
            var fontStack = 'FE-Schrift, PT Sans Narrow, Helvetica Neue Condensed, Arial Narrow, sans-serif';
            var displayTuev = kfzTuevJahr || '27';
            // Anhang fuer E-Auto: " E" wird an die rechtsste Text-Komponente gehaengt
            var zahlenDisplay = kfzZahlen + (kfzEAuto && !kfzIsFreitext ? ' E' : '');
            var freitextDisplay = kfzFreitext + (kfzEAuto && kfzIsFreitext ? ' E' : '');
            // Block-Width berechnen
            var blockW = 0;
            if (kfzIsFreitext) {
              // Freitext: links + plak + rechts (Plak-Position 2 chars vom Anfang als Default)
              var ftPos = parseInt(m.properties['_Plakette-Position'] || '2', 10);
              if (isNaN(ftPos) || ftPos < 0) ftPos = 2;
              if (ftPos > freitextDisplay.length) ftPos = freitextDisplay.length;
              var ftLeft = freitextDisplay.substring(0, ftPos).replace(/\s+$/, '');
              var ftRight = freitextDisplay.substring(ftPos).replace(/^\s+/, '');
              var anyPlak = kfzPlakObenZeigen || kfzPlakUntenZeigen;
              if (anyPlak) {
                var lwf = approxW(ftLeft, L.FONT);
                var rwf = approxW(ftRight, L.FONT);
                blockW = lwf + (lwf > 0 ? L.GAP_PB : 0) + L.PLAK_R*2 + (rwf > 0 ? L.GAP_PB : 0) + rwf;
              } else {
                blockW = approxW(freitextDisplay, L.FONT);
              }
            } else {
              var sw = approxW(kfzStadt || 'B', L.FONT);
              var bw = approxW(kfzBuchstaben || 'AB', L.FONT);
              var zw = approxW(zahlenDisplay || '1234', L.FONT);
              blockW = sw + L.GAP_SP + L.PLAK_R*2 + L.GAP_PB + bw + L.GAP_BZ + zw;
            }
            // dynW: ohne Saison symmetrisches Padding, mit Saison kompakter rechter Sitz
            var dynW;
            if (kfzSaisonAktiv) dynW = L.AREA_START + blockW + L.GAP_BLOCK_SAISON + L.SAISON_W + L.SAISON_PADDING_RIGHT;
            else dynW = L.AREA_START + blockW + L.PADDING_RIGHT;
            dynW = Math.max(240, Math.min(1200, Math.round(dynW)));
            // SVG Pre: Frame + EU-Banner + Sterne + D (auf 60-Plate Geometrie, synchron zur Funnel-Section)
            var svgPre = ''
              + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + dynW + ' ' + L.H + '" class="lw-cart-prop__kfz-svg" aria-label="Kennzeichen-Vorschau ' + escAttr(kfzFull) + '">'
              + '<rect x="0" y="0" width="' + dynW + '" height="' + L.H + '" rx="3" ry="3" fill="#0e1013"/>'
              + '<rect x="4" y="4" width="' + (dynW - 8) + '" height="52" rx="1.5" ry="1.5" fill="#ffffff"/>'
              + '<rect x="4" y="4" width="30" height="52" rx="1.5" ry="1.5" fill="#003a7c"/>'
              + '<rect x="22" y="4" width="12" height="52" fill="#003a7c"/>'
              + '<g fill="#fcd116">'
                + '<circle cx="19" cy="12" r="0.85"/><circle cx="21.5" cy="12.7" r="0.85"/><circle cx="23.3" cy="14.5" r="0.85"/>'
                + '<circle cx="24" cy="17" r="0.85"/><circle cx="23.3" cy="19.5" r="0.85"/><circle cx="21.5" cy="21.3" r="0.85"/>'
                + '<circle cx="19" cy="22" r="0.85"/><circle cx="16.5" cy="21.3" r="0.85"/><circle cx="14.7" cy="19.5" r="0.85"/>'
                + '<circle cx="14" cy="17" r="0.85"/><circle cx="14.7" cy="14.5" r="0.85"/><circle cx="16.5" cy="12.7" r="0.85"/>'
              + '</g>'
              + '<text x="19" y="43" fill="#ffffff" font-family="Inter, Helvetica, Arial, sans-serif" font-weight="900" font-size="11" text-anchor="middle" dominant-baseline="middle">D</text>';
            // TUEV-Plakette OBEN (skaliert auf R=8, gleich wie Funnel)
            function kfzTuevPlakette(cx, cy) {
              return ''
                + '<g transform="translate(' + cx + ' ' + cy + ')">'
                + '<circle cx="0" cy="0" r="' + L.PLAK_R + '" fill="' + escAttr(kfzObenHex) + '" stroke="#0e1013" stroke-width="1.2"/>'
                + '<g stroke="' + escAttr(kfzObenInk) + '" stroke-width="0.9" stroke-linecap="round">'
                  + '<line x1="0" y1="-7" x2="0" y2="-5"/><line x1="7" y1="0" x2="5" y2="0"/>'
                  + '<line x1="0" y1="7" x2="0" y2="5"/><line x1="-7" y1="0" x2="-5" y2="0"/>'
                + '</g>'
                + '<path d="M 0 -8 L -1.4 -4.5 L 1.4 -4.5 Z" fill="' + escAttr(kfzObenInk) + '"/>'
                + (kfzTuevSichtbar ? ('<text x="0" y="0" fill="' + escAttr(kfzObenInk) + '" font-family="Inter, Helvetica, Arial, sans-serif" font-weight="800" font-size="7.5" text-anchor="middle" dominant-baseline="central">' + esc(displayTuev) + '</text>') : '')
                + '</g>';
            }
            // Body rendern
            var kfzSvgBody = '';
            if (kfzIsFreitext) {
              var ftPos2 = parseInt(m.properties['_Plakette-Position'] || '2', 10);
              if (isNaN(ftPos2) || ftPos2 < 0) ftPos2 = 2;
              if (ftPos2 > freitextDisplay.length) ftPos2 = freitextDisplay.length;
              var ftLeft2 = freitextDisplay.substring(0, ftPos2).replace(/\s+$/, '');
              var ftRight2 = freitextDisplay.substring(ftPos2).replace(/^\s+/, '');
              var anyPlak2 = kfzPlakObenZeigen || kfzPlakUntenZeigen;
              if (!anyPlak2) {
                kfzSvgBody += '<text x="' + L.AREA_START + '" y="' + L.Y_TEXT + '" fill="#0e1013" font-family="' + fontStack + '" font-weight="400" font-size="' + L.FONT + '" text-anchor="start" dominant-baseline="middle" letter-spacing="2">' + esc(freitextDisplay) + '</text>';
              } else {
                var cur = L.AREA_START;
                var lwm = approxW(ftLeft2, L.FONT);
                var rwm = approxW(ftRight2, L.FONT);
                if (lwm > 0) {
                  kfzSvgBody += '<text x="' + cur + '" y="' + L.Y_TEXT + '" fill="#0e1013" font-family="' + fontStack + '" font-weight="400" font-size="' + L.FONT + '" text-anchor="start" dominant-baseline="middle" letter-spacing="2">' + esc(ftLeft2) + '</text>';
                  cur += lwm + L.GAP_PB;
                }
                var plakCx = cur + L.PLAK_R;
                if (kfzPlakObenZeigen) kfzSvgBody += kfzTuevPlakette(plakCx, L.Y_OBEN);
                if (kfzPlakUntenZeigen) kfzSvgBody += '<circle cx="' + plakCx + '" cy="' + L.Y_UNTEN + '" r="' + L.PLAK_R + '" fill="' + escAttr(kfzUntenHex) + '" stroke="#0e1013" stroke-width="1.2"/>';
                cur += L.PLAK_R*2;
                if (rwm > 0) {
                  cur += L.GAP_PB;
                  kfzSvgBody += '<text x="' + cur + '" y="' + L.Y_TEXT + '" fill="#0e1013" font-family="' + fontStack + '" font-weight="400" font-size="' + L.FONT + '" text-anchor="start" dominant-baseline="middle" letter-spacing="2">' + esc(ftRight2) + '</text>';
                }
              }
            } else {
              var cs = L.AREA_START;
              kfzSvgBody += '<text x="' + cs + '" y="' + L.Y_TEXT + '" fill="#0e1013" font-family="' + fontStack + '" font-weight="400" font-size="' + L.FONT + '" text-anchor="start" dominant-baseline="middle" letter-spacing="2">' + esc(kfzStadt || 'B') + '</text>';
              cs += approxW(kfzStadt || 'B', L.FONT) + L.GAP_SP;
              var plakCxS = cs + L.PLAK_R;
              kfzSvgBody += kfzTuevPlakette(plakCxS, L.Y_OBEN);
              kfzSvgBody += '<circle cx="' + plakCxS + '" cy="' + L.Y_UNTEN + '" r="' + L.PLAK_R + '" fill="' + escAttr(kfzUntenHex) + '" stroke="#0e1013" stroke-width="1.2"/>';
              cs += L.PLAK_R*2 + L.GAP_PB;
              kfzSvgBody += '<text x="' + cs + '" y="' + L.Y_TEXT + '" fill="#0e1013" font-family="' + fontStack + '" font-weight="400" font-size="' + L.FONT + '" text-anchor="start" dominant-baseline="middle" letter-spacing="2">' + esc(kfzBuchstaben || 'AB') + '</text>';
              cs += approxW(kfzBuchstaben || 'AB', L.FONT) + L.GAP_BZ;
              kfzSvgBody += '<text x="' + cs + '" y="' + L.Y_TEXT + '" fill="#0e1013" font-family="' + fontStack + '" font-weight="400" font-size="' + L.FONT + '" text-anchor="start" dominant-baseline="middle" letter-spacing="2">' + esc(zahlenDisplay || '1234') + '</text>';
            }
            // Saison-Block ganz rechts
            if (kfzSaisonAktiv) {
              var sbCx = (dynW - L.SAISON_PADDING_RIGHT) - (L.SAISON_W / 2);
              var sbVon = kfzSaisonVon || 'V';
              var sbBis = kfzSaisonBis || 'B';
              var sbOpa = (kfzSaisonVon && kfzSaisonBis) ? '1' : '0.32';
              kfzSvgBody += '<text x="' + sbCx + '" y="16" fill="#0e1013" font-family="Inter, Helvetica, Arial, sans-serif" font-weight="800" font-size="10" text-anchor="middle" dominant-baseline="middle" opacity="' + sbOpa + '">' + esc(sbVon) + '</text>';
              kfzSvgBody += '<line x1="' + (sbCx - 5) + '" y1="30" x2="' + (sbCx + 5) + '" y2="30" stroke="#0e1013" stroke-width="0.9"/>';
              kfzSvgBody += '<text x="' + sbCx + '" y="44" fill="#0e1013" font-family="Inter, Helvetica, Arial, sans-serif" font-weight="800" font-size="10" text-anchor="middle" dominant-baseline="middle" opacity="' + sbOpa + '">' + esc(sbBis) + '</text>';
            }
            var kfzSvg = svgPre + kfzSvgBody + '</svg>';
            pImg = '<div class="lw-cart-prop__thumb lw-cart-prop__thumb--kfz" aria-hidden="true">' + kfzSvg + '</div>';
          }
        }
        /* === KFZ-MOTORRAD-FUNNEL: 2-zeiliges hochkant Kennzeichen-Schild als Inline-SVG ===
           Pilot 9 (28.05.2026). Naming-SOP: _HU-Plakette-* + _Stadt-Siegel-* + _H-Kennzeichen + _Saison-*.
           Row 1: Stadt-Code + HU-Plak + Stadt-Siegel (nebeneinander). Row 2: Buchstaben + Zahlen (+ H).
           Saison-Vertikalblock ganz rechts auf Row 2 (zwei kleine Ziffern übereinander). */
        if (otFunnelType === 'kennzeichen-motorrad') {
          var mrFull = (m.properties['Kennzeichen'] || '').toString().trim();
          var mrModus = (m.properties['_Kennzeichen-Modus'] || 'strukturiert').toString();
          var mrIsFreitext = mrModus === 'freitext';
          var mrFreitext = (m.properties['_Kennzeichen-Freitext'] || '').toString().trim().toUpperCase();
          var mrStadt = (m.properties['_Kennzeichen-Stadt'] || '').toString().trim().toUpperCase();
          var mrBuchstaben = (m.properties['_Kennzeichen-Buchstaben'] || '').toString().trim().toUpperCase();
          var mrZahlen = (m.properties['_Kennzeichen-Zahlen'] || '').toString().trim();
          var mrHuZiffer = (m.properties['_HU-Plakette-Ziffer'] || '24').toString().trim();
          var mrHuZifferSichtbar = (m.properties['_HU-Plakette-Ziffer-Sichtbar'] || 'true') !== 'false';
          var mrHuSichtbar = (m.properties['_HU-Plakette-Sichtbar'] || 'true') !== 'false';
          var mrHuHex = m.properties['_HU-Plakette-Hex'] || '#F1C40F';
          var mrSsHex = m.properties['_Stadt-Siegel-Hex'] || '#003a7c';
          var mrSsSichtbar = (m.properties['_Stadt-Siegel-Sichtbar'] || 'true') !== 'false';
          var mrHKennzeichen = (m.properties['_H-Kennzeichen'] || 'false') === 'true';
          var mrSaisonAktiv = (m.properties['_Saison-Aktiv'] || 'false') === 'true';
          var mrSaisonVon = (m.properties['_Saison-Von'] || '').toString().trim();
          var mrSaisonBis = (m.properties['_Saison-Bis'] || '').toString().trim();
          if (!mrIsFreitext && (!mrStadt || !mrBuchstaben || !mrZahlen) && mrFull) {
            // Backward-Compat: aus Full splitten wenn Einzelfelder fehlen
            // Format: "STADT-BUCH ZAHL[H]"
            var mrPartsDash = mrFull.split('-');
            mrStadt = mrStadt || (mrPartsDash[0] || '').toUpperCase();
            if (mrPartsDash[1]) {
              var mrRight = mrPartsDash[1].trim().replace(/H$/, '');
              var mrRightParts = mrRight.split(/\s+/);
              mrBuchstaben = mrBuchstaben || (mrRightParts[0] || '').toUpperCase();
              mrZahlen = mrZahlen || (mrRightParts[1] || '');
            }
          }
          if (mrIsFreitext && !mrFreitext && mrFull) mrFreitext = mrFull.replace(/H$/, '').toUpperCase();
          var mrHasContent = mrIsFreitext ? !!mrFreitext : (mrStadt || mrBuchstaben || mrZahlen);
          if (mrHasContent) {
            function mrInk(hex) {
              var ink = '#0e1013';
              var hxx = String(hex || '').replace('#', '');
              if (hxx.length === 3) hxx = hxx[0]+hxx[0]+hxx[1]+hxx[1]+hxx[2]+hxx[2];
              if (hxx.length === 6) {
                var rr = parseInt(hxx.substr(0,2),16);
                var gg = parseInt(hxx.substr(2,2),16);
                var bb = parseInt(hxx.substr(4,2),16);
                if (!isNaN(rr) && !isNaN(gg) && !isNaN(bb)) {
                  var lm = 0.299*rr + 0.587*gg + 0.114*bb;
                  if (lm < 130) ink = '#ffffff';
                }
              }
              return ink;
            }
            var mrHuInk = mrInk(mrHuHex);
            // 2-row Mini-SVG: viewBox-Höhe 96 (hochkant), Plak R=10
            var ML = {
              H: 96, AREA_START: 42, FONT: 22,
              PLAK_R: 10, GAP_TP: 8, GAP_PP: 4, GAP_H: 2, GAP_SAISON: 4, SAISON_W: 16,
              PADDING_RIGHT: 8, LETTER_SPACING: 1.5,
              Y_ROW1: 28, Y_ROW2: 70
            };
            function mrApproxW(text, fontSize) {
              if (!text) return 0;
              return text.length * (fontSize * 0.50) + Math.max(0, text.length - 1) * ML.LETTER_SPACING;
            }
            var mrFont = 'FE-Schrift, PT Sans Narrow, Helvetica Neue Condensed, Arial Narrow, sans-serif';
            var mrHSuffix = mrHKennzeichen ? 'H' : '';
            // Row 1: Stadt + opt HU + opt Siegel
            var mrPlakCount = (mrHuSichtbar ? 1 : 0) + (mrSsSichtbar ? 1 : 0);
            var mrStadtText = mrIsFreitext
              ? '' // bei Freitext steht alles in Row 2
              : (mrStadt || 'M');
            var mrStadtW = mrApproxW(mrStadtText, ML.FONT);
            var mrPlakW = mrPlakCount > 0 ? (mrPlakCount * ML.PLAK_R * 2 + (mrPlakCount - 1) * ML.GAP_PP) : 0;
            var mrRow1GapTP = (mrStadtW > 0 && mrPlakCount > 0) ? ML.GAP_TP : 0;
            var mrRow1W = mrStadtW + mrRow1GapTP + mrPlakW;
            // Row 2: Buchstaben + Zahlen (+H) oder Freitext
            var mrRow2Text = mrIsFreitext ? mrFreitext : (mrBuchstaben + (mrZahlen ? ' ' + mrZahlen : ''));
            var mrRow2W = mrApproxW(mrRow2Text, ML.FONT) + (mrHSuffix ? (ML.GAP_H + mrApproxW(mrHSuffix, ML.FONT)) : 0);
            var mrSaisonW = mrSaisonAktiv ? (ML.GAP_SAISON + ML.SAISON_W) : 0;
            mrRow2W += mrSaisonW;
            var mrInnerW = Math.max(mrRow1W, mrRow2W);
            var mrDynW = ML.AREA_START + mrInnerW + ML.PADDING_RIGHT;
            mrDynW = Math.max(220, Math.min(1100, Math.round(mrDynW)));
            // SVG Pre
            var mrSvgPre = ''
              + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + mrDynW + ' ' + ML.H + '" class="lw-cart-prop__kfz-svg" aria-label="Motorrad-Kennzeichen-Vorschau ' + escAttr(mrFull) + '">'
              + '<rect x="0" y="0" width="' + mrDynW + '" height="' + ML.H + '" rx="4" ry="4" fill="#0e1013"/>'
              + '<rect x="4" y="4" width="' + (mrDynW - 8) + '" height="' + (ML.H - 8) + '" rx="2" ry="2" fill="#ffffff"/>'
              + '<rect x="6" y="6" width="32" height="' + (ML.H - 12) + '" rx="2" ry="2" fill="#003a7c"/>'
              + '<g fill="#fcd116">'
                + '<circle cx="22" cy="18" r="0.9"/><circle cx="24.5" cy="18.8" r="0.9"/><circle cx="26.3" cy="20.6" r="0.9"/>'
                + '<circle cx="27" cy="23" r="0.9"/><circle cx="26.3" cy="25.4" r="0.9"/><circle cx="24.5" cy="27.2" r="0.9"/>'
                + '<circle cx="22" cy="28" r="0.9"/><circle cx="19.5" cy="27.2" r="0.9"/><circle cx="17.7" cy="25.4" r="0.9"/>'
                + '<circle cx="17" cy="23" r="0.9"/><circle cx="17.7" cy="20.6" r="0.9"/><circle cx="19.5" cy="18.8" r="0.9"/>'
              + '</g>'
              + '<text x="22" y="62" fill="#ffffff" font-family="Inter, Helvetica, Arial, sans-serif" font-weight="900" font-size="12" text-anchor="middle" dominant-baseline="middle">D</text>';
            // HU-Plak-Funktion
            function mrTuevPlak(cx, cy) {
              return '<g transform="translate(' + cx + ' ' + cy + ')">'
                + '<circle cx="0" cy="0" r="' + ML.PLAK_R + '" fill="' + escAttr(mrHuHex) + '" stroke="#0e1013" stroke-width="1"/>'
                + '<g stroke="' + escAttr(mrHuInk) + '" stroke-width="0.8" stroke-linecap="round">'
                  + '<line x1="0" y1="-8.5" x2="0" y2="-6.5"/><line x1="8.5" y1="0" x2="6.5" y2="0"/>'
                  + '<line x1="0" y1="8.5" x2="0" y2="6.5"/><line x1="-8.5" y1="0" x2="-6.5" y2="0"/>'
                + '</g>'
                + '<path d="M 0 -10 L -1.6 -5.5 L 1.6 -5.5 Z" fill="' + escAttr(mrHuInk) + '"/>'
                + (mrHuZifferSichtbar ? '<text x="0" y="0.5" fill="' + escAttr(mrHuInk) + '" font-family="Inter, Helvetica, Arial, sans-serif" font-weight="800" font-size="8" text-anchor="middle" dominant-baseline="central">' + esc(mrHuZiffer) + '</text>' : '')
                + '</g>';
            }
            // Body
            var mrBody = '';
            // ROW 1 (centered within mrInnerW)
            var mrR1Cx = ML.AREA_START + (mrInnerW - mrRow1W) / 2;
            if (mrStadtW > 0) {
              mrBody += '<text x="' + mrR1Cx + '" y="' + ML.Y_ROW1 + '" fill="#0e1013" font-family="' + mrFont + '" font-weight="400" font-size="' + ML.FONT + '" text-anchor="start" dominant-baseline="middle" letter-spacing="1.5">' + esc(mrStadtText) + '</text>';
              mrR1Cx += mrStadtW + mrRow1GapTP;
            }
            if (mrHuSichtbar) {
              mrBody += mrTuevPlak(mrR1Cx + ML.PLAK_R, ML.Y_ROW1);
              mrR1Cx += ML.PLAK_R * 2 + (mrSsSichtbar ? ML.GAP_PP : 0);
            }
            if (mrSsSichtbar) {
              mrBody += '<circle cx="' + (mrR1Cx + ML.PLAK_R) + '" cy="' + ML.Y_ROW1 + '" r="' + ML.PLAK_R + '" fill="' + escAttr(mrSsHex) + '" stroke="#0e1013" stroke-width="1"/>';
            }
            // ROW 2 (centered within mrInnerW)
            var mrR2Cx = ML.AREA_START + (mrInnerW - mrRow2W) / 2;
            mrBody += '<text x="' + mrR2Cx + '" y="' + ML.Y_ROW2 + '" fill="#0e1013" font-family="' + mrFont + '" font-weight="400" font-size="' + ML.FONT + '" text-anchor="start" dominant-baseline="middle" letter-spacing="1.5">' + esc(mrRow2Text) + '</text>';
            if (mrHSuffix) {
              var mrHCx = mrR2Cx + mrApproxW(mrRow2Text, ML.FONT) + ML.GAP_H;
              mrBody += '<text x="' + mrHCx + '" y="' + ML.Y_ROW2 + '" fill="#0e1013" font-family="' + mrFont + '" font-weight="400" font-size="' + ML.FONT + '" text-anchor="start" dominant-baseline="middle" letter-spacing="1.5">H</text>';
            }
            if (mrSaisonAktiv && mrSaisonVon && mrSaisonBis) {
              var mrSbCx = mrR2Cx + mrApproxW(mrRow2Text, ML.FONT) + (mrHSuffix ? (ML.GAP_H + mrApproxW(mrHSuffix, ML.FONT)) : 0) + ML.GAP_SAISON + ML.SAISON_W / 2;
              mrBody += '<text x="' + mrSbCx + '" y="' + (ML.Y_ROW2 - 8) + '" fill="#0e1013" font-family="Inter, Helvetica, Arial, sans-serif" font-weight="800" font-size="10" text-anchor="middle" dominant-baseline="middle">' + esc(mrSaisonVon) + '</text>';
              mrBody += '<text x="' + mrSbCx + '" y="' + (ML.Y_ROW2 + 8) + '" fill="#0e1013" font-family="Inter, Helvetica, Arial, sans-serif" font-weight="800" font-size="10" text-anchor="middle" dominant-baseline="middle">' + esc(mrSaisonBis) + '</text>';
            }
            var mrSvg = mrSvgPre + mrBody + '</svg>';
            pImg = '<div class="lw-cart-prop__thumb lw-cart-prop__thumb--kfz" aria-hidden="true">' + mrSvg + '</div>';
          }
        }
        /* v38: Die beiden Bild-Links sind versteckt (_-Prefix), damit sie nicht auf
           Rechnung und Bestaetigungsmail landen - im Warenkorb wollen wir sie aber
           zeigen. Darum gezielt holen, sichtbare Alt-Namen weiter unterstuetzt
           (Warenkoerbe, die vor der Umstellung angelegt wurden). */
        var _propAny=function(k){ return m.properties['_'+k] || m.properties[k] || ''; };
        var _isUrl=function(u){ return typeof u==='string' && /^https?:\/\//i.test(u); };
        /* Round 21: Die fertige KI-Lampen-Vorschau ist das wertvollste Bild und
           wird IMMER als grosser Thumbnail bevorzugt — vor dem rohen Logo-Upload. */
        var _thumbKey='';
        var _lv=_propAny('Lampen-Vorschau');
        if(typeof _lv==='string' && /^https?:\/\//i.test(_lv)){
          pImg='<a class="lw-cart-prop__thumb lw-cart-prop__thumb--preview" href="'+escAttr(_lv)+'" target="_blank" rel="noopener" title="Deine Lampen-Vorschau in groß ansehen">'+
               '<img src="'+escAttr(_lv)+'" alt="Lampen-Vorschau" loading="lazy"/>'+
               '<span class="lw-cart-prop__thumb-zoom" aria-hidden="true">'+
                 '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>'+
               '</span>'+
               '</a>';
          _thumbKey='Lampen-Vorschau';
        }
        for(var pk in m.properties){
          if(!Object.prototype.hasOwnProperty.call(m.properties,pk))continue;
          if(pk.charAt(0)==='_')continue;
          if(pk===_thumbKey)continue;
          var pv=m.properties[pk];
          if(!pv)continue;
          var displayLabel = labelMap[pk] || pk;
          /* Image-Detection: muss URL sein UND Image-Extension ODER Cloudinary */
          var isImg = typeof pv==='string' && /^https?:\/\//i.test(pv) && (
            /\.(jpg|jpeg|png|webp|gif)(\?|$|\/)/i.test(pv) ||
            pv.indexOf('cloudinary.com') !== -1
          );
          if(isImg && !pImg){
            /* Cloudinary: kompakte Thumbnail-Variante via Transformation */
            var thumbUrl = pv;
            if(pv.indexOf('cloudinary.com') !== -1 && pv.indexOf('/upload/') !== -1){
              thumbUrl = pv.replace('/upload/', '/upload/c_fill,w_160,h_160,q_auto,f_auto/');
            }
            pImg = '<a class="lw-cart-prop__thumb" href="'+escAttr(pv)+'" target="_blank" rel="noopener" title="'+escAttr(displayLabel)+' in groß ansehen">'+
                   '<img src="'+escAttr(thumbUrl)+'" alt="'+escAttr(displayLabel)+'" loading="lazy"/>'+
                   '<span class="lw-cart-prop__thumb-zoom" aria-hidden="true">'+
                     '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>'+
                   '</span>'+
                   '</a>';
          } else if(isImg){
            /* Round 21: weiteres Bild (z.B. rohes Logo) — als klickbarer Link
               rendern, NICHT als roher URL-Text (war vorher nicht klickbar). */
            pTextRows.push({k:displayLabel,v:pv,link:pv});
          } else {
            pTextRows.push({k:displayLabel,v:pv});
          }
        }
        /* v38: Hochgeladene Datei - versteckt gespeichert, im Drawer trotzdem als
           "Originaldatei" verlinkt. Ist sie das einzige Bild, traegt sie den Thumbnail. */
        var _up=_propAny('Logo-Vorschau');
        if(_isUrl(_up) && !m.properties['Logo-Vorschau']){
          if(!pImg){
            var upThumb=_up.indexOf('cloudinary.com')!==-1 && _up.indexOf('/upload/')!==-1
              ? _up.replace('/upload/','/upload/c_fill,w_160,h_160,q_auto,f_auto/') : _up;
            pImg='<a class="lw-cart-prop__thumb" href="'+escAttr(_up)+'" target="_blank" rel="noopener" title="Originaldatei in groß ansehen">'+
                 '<img src="'+escAttr(upThumb)+'" alt="Originaldatei" loading="lazy"/>'+
                 '<span class="lw-cart-prop__thumb-zoom" aria-hidden="true">'+
                   '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>'+
                 '</span>'+
                 '</a>';
          } else {
            pTextRows.push({k:'Originaldatei',v:_up,link:_up});
          }
        }
        /* v38: Beim Funnel steckt die Groesse in den Properties, auf den Perso-PDPs
           in der Variante - dort waere sie im Drawer sonst nirgends zu sehen. */
        if(isPersoItem && g.vt && g.vt !== 'Default Title'){
          var hasSize=false;
          for(var sr=0;sr<pTextRows.length;sr++){ if(/gr(ö|oe)sse/i.test(pTextRows[sr].k)) hasSize=true; }
          if(!hasSize) pTextRows.unshift({k:'Größe',v:String(g.vt).replace(/\s*\/\s*/g,' · ')});
        }
        if(pImg || pTextRows.length){
          pH='<div class="lw-cart-props">';
          pH+='<div class="lw-cart-props__head">Deine Personalisierung</div>';
          pH+='<div class="lw-cart-props__body">';
          if(pImg){
            pH+='<div class="lw-cart-props__thumb-wrap">'+pImg+'</div>';
          }
          pH+='<div class="lw-cart-props__list">';
          /* Stacked-Mode-Detection: ALLE personalisierbaren Lampen (Funnel-Typ gesetzt)
             rendern wir mit Label oben + Wert drunter (full-width) statt inline-Grid.
             Das gibt allen Werten - kurz wie lang - volle Container-Breite + bündige Optik. */
          var isPersonalisierterFunnel = !!otFunnelType;
          for(var pi=0;pi<pTextRows.length;pi++){
            var pr=pTextRows[pi];
            var prValStr = String(pr.v || '');
            // Stacked: jede Personalisierungs-Lampe ODER bei sehr langen Werten (>14 chars)
            var useStacked = isPersonalisierterFunnel || prValStr.length > 14;
            var propClass = 'lw-cart-prop' + (useStacked ? ' lw-cart-prop--stacked' : '');
            pH+='<div class="'+propClass+'">';
            pH+='<span class="lw-cart-prop__label">'+esc(pr.k)+'</span>';
            if(pr.link){
              /* Round 21: Bild-Wert als klickbarer Link statt nackter URL. */
              pH+='<a class="lw-cart-prop__value lw-cart-prop__value--link" href="'+escAttr(pr.link)+'" target="_blank" rel="noopener">Ansehen ↗</a>';
            } else {
              pH+='<span class="lw-cart-prop__value" title="'+escAttr(pr.v)+'">'+esc(pr.v)+'</span>';
            }
            pH+='</div>';
          }
          pH+='</div>';
          pH+='</div>';
          pH+='</div>';
        }
      }
      /* ⚠️ EIN WRAPPER UM DIE GANZE PREISZEILE (22.09.2026). Ohne ihn durfte
         der Browser zwischen Betrag und Euro-Zeichen umbrechen; auf dem
         Handy stand "90,00" in der Zeile und "€" allein darunter. Der
         Wrapper traegt white-space: nowrap, siehe .lw-ipw in
         assets/lw-cart-drawer.css.
         ⚠️ DIE ERSPARNIS STEHT ALS ROTE PILLE DANEBEN, nicht als Farbe am
         Betrag. Rot bedeutet im Shop "Nachlass" - also gehoert es an die
         Zahl, die den Nachlass benennt, nicht an die, die der Kunde zahlt.
         Aufgerundet auf volle Prozent wie in der Kaufspalte; ergibt die
         Rechnung 0 %, bleibt die Pille leer und CSS blendet sie aus. */
      var priceHtml;
      if(g.origPrice>dp){
        var sparPct=Math.round((1-dp/g.origPrice)*100);
        priceHtml='<span class="lw-ipw"><span class="lw-ip-old">'+fmt(g.origPrice)+'</span>'+
                  '<span class="lw-ip-new">'+fmt(dp)+'</span>'+
                  '<span class="lw-ip-pct">'+(sparPct>0?('\u2212'+sparPct+' %'):'')+'</span></span>';
      } else {
        priceHtml='<span class="lw-ipw"><span class="lw-ip">'+fmt(dp)+'</span></span>';
      }
      html+='<div class="lw-it" data-k="'+escAttr(m.key)+'"><div class="lw-iw"><a href="'+escAttr(m.url)+'" tabindex="-1">'+(img?'<img class="lw-ii" src="'+escAttr(img)+'" alt="'+escAttr(m.featured_image&&m.featured_image.alt||m.product_title)+'" loading="lazy">':'')+'</a></div><div class="lw-id"><a class="lw-in" href="'+escAttr(m.url)+'">'+esc(dispTitle)+'</a>'+setHtml+bH+pH+wH+'<div class="lw-ib2"><div>'+priceHtml+'</div><div class="lw-q"><button class="lw-qb" data-a="d" data-k="'+escAttr(m.key)+'" type="button"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="2" y1="6" x2="10" y2="6"/></svg></button><input class="lw-qi" type="number" value="'+m.quantity+'" min="1" data-k="'+escAttr(m.key)+'"><button class="lw-qb" data-a="i" data-k="'+escAttr(m.key)+'" type="button"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="6" y1="2" x2="6" y2="10"/><line x1="2" y1="6" x2="10" y2="6"/></svg></button></div></div></div><button class="lw-ir" data-k="'+escAttr(m.key)+'" type="button"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg></button></div>';
    }
    c.innerHTML=html;
    bindEvents();
  }
  /* ⚠️ DER FUSS HAT SEIT DEM 09.09.2026 ZWEI ZEILEN, NICHT FUENF.
     Max: "mach den preis unten im side cart in der schwarzen zeile raus ...
     und dafuer dann die preise unten ganz klar aufschreiben", danach die Wahl
     zwischen vier Entwuerfen: Versandkosten, dann der Gesamtbetrag mit dem
     durchgestrichenen Vergleichsbetrag daneben.

     ⚠️ DER GESAMTBETRAG IST cart.total_price PLUS VERSAND, und das ist die
     Zahl, die bis heute auf dem Knopf stand. Die alte Zwischensumme war es
     NICHT: bei einer einzelnen Lampe fehlten ihr die 4,90 EUR.

     ⚠️ DER STREICHPREIS TRAEGT DENSELBEN VERSAND WIE DER ENDBETRAG. Er sagt,
     was DIESER Korb ohne Rabatt kosten wuerde. Ohne den Versand darin stuende
     bei einer rabattierten Einzellampe ein "vorher" UNTER dem Endbetrag.
     Die Herleitung steht ausfuehrlich im Markup-Kommentar in
     snippets/lw-cart-drawer.liquid.

     ⚠️ GEZEIGT WIRD ER NUR BEI EINEM ECHTEN ABZUG, und die Bedingung dafuer
     ist wert > cart.total_price - eine einzige Zahl statt der alten Liste aus
     collectDiscounts(). Sie faengt alle drei Sorten zugleich: den
     Sale-Rabatt aus _reg, den Mengenrabatt auf der Zeile und den
     Rabattcode auf Korbebene. cart.total_price steht hinter allen dreien,
     getWarenwert() vor allen dreien. */
  function renderFooter(){
    var wert=getWarenwert();
    var ship=getShipping();
    var gesamt=cart.total_price+ship;
    var tv=qs('#lw-total-val');if(tv)tv.textContent=fmt(gesamt);
    var ta=qs('#lw-total-alt');
    if(ta){
      var zeigen=wert>cart.total_price;
      if(zeigen){
        var av=ta.querySelector('#lw-total-alt-val')||ta;
        av.textContent=fmt(wert+ship);
      }
      ta.hidden=!zeigen;
    }
    var sv=qs('#lw-ship-val');
    if(sv){
      if(ship===0){
        sv.textContent='Kostenlos';
        sv.className='lw-ship-free';
      } else {
        sv.textContent=fmt(ship);
        sv.className='';
      }
    }
    renderProgress(getBundleCount());
  }
  function renderCount(){
    if(!cart)return;
    var n=getLampCount();
    var updated=false;
    qa('.cart-count-bubble span[aria-hidden]').forEach(function(sp){sp.textContent=n;updated=true;});
    qa('.cart-count-bubble .visually-hidden').forEach(function(sp){sp.textContent=n+' Artikel';});
    if(!updated&&n>0){
      var wrap=qs('.lw24-cart-wrap')
        ||document.querySelector('cart-icon-bubble')
        ||qs('#cart-icon-bubble')
        ||qs('.header__icon--cart');
      if(wrap){
        var bub=document.createElement('div');
        bub.className='cart-count-bubble';
        bub.innerHTML='<span aria-hidden="true">'+n+'</span><span class="visually-hidden">'+n+' Artikel</span>';
        var target=wrap.querySelector('.lw24-cart-wrap')||wrap;
        target.appendChild(bub);
      }
    }
    qa('.cart-count-bubble').forEach(function(b){
      if(n>0){b.style.display='';b.style.visibility='visible';b.removeAttribute('hidden');}
      else{b.style.display='none';}
    });
  }
  /* ⚠️ HIER STAND updateShipNudge(), 21 ZEILEN FUER EIN ELEMENT, DAS ES
     SEIT ROUND 24 NICHT MEHR GIBT (geloescht am 07.09.2026).
     #lw-ship-nudge steht in keinem Markup des Themes; der Kopfkommentar von
     snippets/lw-cart-drawer.liquid sagt das selbst ("existiert NICHT MEHR im
     DOM ... laeuft also einfach ins Leere"). Die Funktion war sauber
     abgesichert und hat nichts kaputtgemacht, aber sie hat bei jedem
     Rendern zweimal das DOM durchsucht und ihre beiden Texte standen als
     zweite Quelle neben denen der Motivationskarte.
     Die Aussage steht jetzt an EINER Stelle: #lw-motiv-headline, gefuehrt
     von Liquid beim ersten Paint und vom Motiv-Sync danach.
     Aufraeumen heisst LOESCHEN, nicht auskommentieren (CLAUDE.md). */
  /* ══════════════════════════════════════════════════════════════════════
     LIEFERTERMIN FUER DEN GANZEN WARENKORB (22.09.2026)

     Max: "Lieferzeit wechselt je nach Größe, alles nach M dauert länger,
     bestellungen gehen immer als ein paket bzw eine order raus, also sobald
     eine größe dabei ist, die nicht M ist, dann die lange lieferzeit
     anzeigen!"

     ⚠️ DAS LANGSAMSTE STUECK BESTIMMT DAS PAKET. Es wird nicht je Zeile
     gerechnet und auch kein Mittelwert gebildet: liegt EINE Lampe ab L im
     Korb, geht das ganze Paket spaeter raus. Wer hier je Zeile rechnet,
     verspricht dem Kunden fuer seine M-Lampe einen Termin, den die Sendung
     nicht haelt.

     ⚠️ DIESELBE TABELLE WIE DIE KAUFSPALTE (LEAD in lw-pdp-standard-v7):
     M 5-7 Werktage, L/XL/XXL 10-12. Wer eine der beiden aendert, aendert
     beide - sonst verspricht die Produktseite etwas anderes als der
     Warenkorb, in den sie fuehrt.

     ⚠️ DIE GROESSE KOMMT AUS DERSELBEN ERKENNUNG WIE DAS GROESSEN-BADGE
     (siehe renderItems): exakter Optionswert zwischen Pipes, danach die
     alten cm-Namen. Ohne Treffer gilt M - das ist die vorsichtigere
     Annahme nur fuer die Erkennung, nicht fuer den Termin: eine Lampe,
     deren Groesse wir nicht lesen koennen, verschiebt das Paket nicht.
     ══════════════════════════════════════════════════════════════════════ */
  var LIEF_WT = { M:[5,7], L:[5,7], XL:[5,7], XXL:[5,7] };
  var LIEF_WD = ['So.','Mo.','Di.','Mi.','Do.','Fr.','Sa.'];
  var LIEF_MN = ['Jan.','Feb.','M\u00e4rz','Apr.','Mai','Juni','Juli','Aug.','Sep.','Okt.','Nov.','Dez.'];
  function liefWerktage(n){
    var d=new Date(),z=0;
    while(z<n){ d.setDate(d.getDate()+1); var w=d.getDay(); if(w!==0&&w!==6) z++; }
    return d;
  }
  function liefTag(d,mitMonat){
    return LIEF_WD[d.getDay()]+' '+d.getDate()+'.'+(mitMonat?' '+LIEF_MN[d.getMonth()]:'');
  }
  function groesseVon(variantTitle){
    var vo='|'+String(variantTitle||'').split(' / ').join('|')+'|';
    if(vo.indexOf('|M|')!==-1) return 'M';
    if(vo.indexOf('|L|')!==-1) return 'L';
    if(vo.indexOf('|XL|')!==-1) return 'XL';
    if(vo.indexOf('|XXL|')!==-1) return 'XXL';
    if(/52\s*cm|mega/i.test(variantTitle)) return 'XXL';
    if(/42\s*cm|maxi/i.test(variantTitle)) return 'XL';
    if(/32\s*cm|premium/i.test(variantTitle)) return 'L';
    return 'M';
  }
  function renderLieferung(){
    var zeile=qs('#lw-lieferung'),feld=qs('#lw-lief-datum');
    if(!zeile||!feld||!cart||!cart.items||!cart.items.length){ if(zeile)zeile.hidden=true; return; }
    /* Aufpreis-Zeilen sind keine Lampen und haben keine Groesse. */
    var lang=false, gefunden=false;
    for(var i=0;i<cart.items.length;i++){
      var it=cart.items[i];
      if(isS(it)) continue;
      gefunden=true;
      if(groesseVon(it.variant_title)!=='M'){ lang=true; break; }
    }
    if(!gefunden){ zeile.hidden=true; return; }
    var sp=lang?LIEF_WT.L:LIEF_WT.M;
    var a=liefWerktage(sp[0]), b=liefWerktage(sp[1]);
    feld.textContent=liefTag(a,a.getMonth()!==b.getMonth())+' bis '+liefTag(b,true);
    zeile.hidden=false;
  }
  function renderAll(){
    if(!cart)return;

    if(cleanupOrphanSurcharges()) return;
    var g=buildGroups(),empty=g.length===0;
    var es=qs('#lw-empty'),fs=qs('#lw-filled');
    if(es)es.style.display=empty?'flex':'none';
    /* #lw-filled via [hidden]-Attribut togglen — NICHT via style.display.
       Die CSS-Layout-Rules fuer #lw-filled sind display:flex !important und
       wuerden ein inline style.display:none ueberstimmen → Geister-Item neben
       dem Empty-State. Das [hidden]-Attribut hat hoehere Spezifitaet + !important
       (siehe lw-cart-drawer CSS) und blendet zuverlaessig aus. */
    if(fs){fs.style.display='';if(empty){fs.setAttribute('hidden','');}else{fs.removeAttribute('hidden');}}
    var btn=qs('#lw-checkout');if(btn)btn.disabled=empty;
    if(!empty){renderItems(g);renderFooter();renderLieferung();}
    else {
      renderProgress(0);
      /* Items-Container leeren — sonst bleibt das zuletzt gerenderte Item als
         Geister-DOM stehen wenn der Cart leer wird (renderItems laeuft nur im
         !empty-Zweig). */
      var ic=qs('#lw-items');if(ic)ic.innerHTML='';_lastItemsSig=null;
      var lz=qs('#lw-lieferung');if(lz)lz.hidden=true;
      var tv=qs('#lw-total-val');if(tv)tv.textContent='0,00 €';
      var ta=qs('#lw-total-alt');if(ta)ta.hidden=true;
      var sv=qs('#lw-ship-val');if(sv){sv.textContent='Wird berechnet';sv.className='';}
      var orphans=false;
      for(var i=0;i<cart.items.length;i++){if(isS(cart.items[i])){orphans=true;break;}}
      if(orphans&&!busy){busy=true;var upd={};for(var j=0;j<cart.items.length;j++){if(isS(cart.items[j]))upd[cart.items[j].key]=0;}
        fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:upd}),credentials:'same-origin'}).then(function(){return fetchCart();}).then(function(){busy=false;renderAll();}).catch(function(){busy=false;});}
    }
    renderCount();
  }
  /* ⚠️ HIER STAND loadUpsells(), DIE EMPFEHLUNGSLISTE UNTER DEM
     WARENKORB (geloescht am 07.09.2026).
     Sie begann mit `if(!s||!w)return;` auf #lw-upsell-list und
     #lw-upsell-wrap, und beide stehen in keinem Markup des Themes: die
     Funktion ist bei jedem Aufruf sofort wieder ausgestiegen. Damit lief
     auch der Fetch auf /recommendations/products.json nie.
     Ihre Stile lagen in assets/lw-cart-drawer.css und sind dort am selben
     Tag gefallen. Aufraeumen heisst LOESCHEN (CLAUDE.md).
     ⚠️ WER DIE LISTE ZURUECKHOLT, braucht zuerst das Markup und baut sie
     dann im neuen Stil neu; die alte Fassung hatte einen schwarzen runden
     Knopf mit Amber-Hover ohne Zeigerschranke. */
  var _nativeFetch=(function(){
    try{var f=window.fetch;if(f&&f.toString().indexOf('native code')!==-1)return f;}catch(e){}
    return window.fetch;
  })();
  function fetchCart(){
    return _nativeFetch.call(window,'/cart.js',{credentials:'same-origin'})
      .then(function(r){
        var ct=r.headers.get('content-type')||'';
        if(ct.indexOf('json')===-1&&ct.indexOf('javascript')===-1){
          return new Promise(function(resolve){setTimeout(resolve,200);})
            .then(function(){return _nativeFetch.call(window,'/cart.js',{credentials:'same-origin'});})
            .then(function(r2){return r2.json();});
        }
        return r.json();
      })
      .then(function(c){cart=c;return c;});
  }
  function updateItem(key,qty){if(busy)return;busy=true;var item=null;for(var i=0;i<cart.items.length;i++){if(cart.items[i].key===key){item=cart.items[i];break;}}var updates={};updates[key]=qty;if(item&&!isS(item)){var props=item.properties||{};if(props['Größe']&&/premium/i.test(props['Größe'])){for(var j=0;j<cart.items.length;j++){if(cart.items[j].variant_id===53955374088532){updates[cart.items[j].key]=qty;break;}}}if(props['Verwendung']&&/drau/i.test(props['Verwendung'])){for(var k=0;k<cart.items.length;k++){if(cart.items[k].variant_id===53957538677076){updates[cart.items[k].key]=qty;break;}}}}fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:updates}),credentials:'same-origin'}).then(function(){return fetchCart();}).then(function(){renderAll();}).finally(function(){busy=false;});}
  function removeItem(key){if(busy)return;busy=true;var item=null;for(var i=0;i<cart.items.length;i++){if(cart.items[i].key===key){item=cart.items[i];break;}}var updates={};updates[key]=0;if(item&&!isS(item)){var props=item.properties||{};if(props['Größe']&&/premium/i.test(props['Größe'])){for(var j=0;j<cart.items.length;j++){if(cart.items[j].variant_id===53955374088532){updates[cart.items[j].key]=0;break;}}}if(props['Verwendung']&&/drau/i.test(props['Verwendung'])){for(var k=0;k<cart.items.length;k++){if(cart.items[k].variant_id===53957538677076){updates[cart.items[k].key]=0;break;}}}}fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:updates}),credentials:'same-origin'}).then(function(){return fetchCart();}).then(function(){renderAll();}).finally(function(){busy=false;});}
  function bindEvents(){qa('.lw-qb').forEach(function(b){b.addEventListener('click',function(){var k=b.dataset.k,inp=b.closest('.lw-q').querySelector('.lw-qi');var q=parseInt(inp.value,10);q=b.dataset.a==='d'?Math.max(0,q-1):q+1;q===0?removeItem(k):updateItem(k,q);});});qa('.lw-qi').forEach(function(inp){var t;inp.addEventListener('change',function(){clearTimeout(t);t=setTimeout(function(){var q=Math.max(0,parseInt(inp.value,10)||0);q===0?removeItem(inp.dataset.k):updateItem(inp.dataset.k,q);},400);});});qa('.lw-ir').forEach(function(b){b.addEventListener('click',function(){removeItem(b.dataset.k);});});}
  function openDrawer(){
    var d=qs('#lw-cart-drawer');if(!d)return;
    if(cart)renderAll();
    // Body-Scroll-Lock mit iOS-Safari-Fix: aktuelle scrollY merken,
    // body fixed positionieren mit -scrollY top (so dass Page visuell stabil bleibt).
    // closeDrawer restored die scrollY-Position.
    try {
      var sy = window.scrollY || window.pageYOffset || 0;
      window.__lwCartScrollY = sy;
      document.body.style.top = '-' + sy + 'px';
    } catch(e) {}
    d.classList.add('is-active');
    document.body.classList.add('lw-drawer-open');
    fetchCart().then(function(){renderAll();}).catch(function(e){console.warn('[LW Cart v27] fetch error:',e);});
  }
  function closeDrawer(){
    var d=qs('#lw-cart-drawer');if(!d)return;
    d.classList.remove('is-active');
    // Guard: nur restoren wenn der Lock auch wirklich noch aktiv ist.
    // Der Dialog-Sync (MutationObserver) + native close-event koennen close()
    // re-entrant ausloesen — ohne Guard wuerde scrollTo(0,0) die Seite nach oben reissen.
    if (document.body.classList.contains('lw-drawer-open')) {
      document.body.classList.remove('lw-drawer-open');
      // Restore scrollY (iOS-Fix - body war auf position:fixed mit top=-scrollY)
      try {
        var sy = window.__lwCartScrollY || 0;
        document.body.style.top = '';
        window.scrollTo(0, sy);
        window.__lwCartScrollY = 0;
      } catch(e) {}
    }
  }
  function triggerSuccessUX(source) {
    var doSuccess = function() {
      renderAll();
      /* 20.05.2026 Funnel-Fix: Warenkorb-Drawer direkt oeffnen.
         Kein sichtbarer Add-to-Cart-Erfolg war ein ATC->Checkout-Leak.
         Banner bleibt; nur die flyToCart-Wischanimation wurde entfernt (buy-buttons). */
      openDrawer();
      if (window.LW24 && window.LW24.showSuccessBanner) {
        window.LW24.showSuccessBanner(source || 'quick-add');
      }
      if (window.LW24 && window.LW24.checkMilestones) {
        window.LW24.checkMilestones();
      }
      if (window.LW24 && window.LW24.refreshBubble) {
        window.LW24.refreshBubble();
      }
    };
    fetchCart().then(doSuccess).catch(function(e){
      console.warn('[LW Cart v27] triggerSuccessUX retry:',e);
      setTimeout(function(){
        fetchCart().then(doSuccess).catch(function(e2){
          console.warn('[LW Cart v27] triggerSuccessUX final fail:',e2);
        });
      },500);
    });
  }
  function patchDawn(){function doPatch(){var dd=document.querySelector('cart-drawer');if(!dd)return false;if(dd._lwP)return true;dd._lwP=true;dd.getSectionsToRender=function(){return[{id:'cart-drawer',selector:'#CartDrawer'},{id:'cart-icon-bubble',selector:'.shopify-section'}];};dd.setActiveElement=function(){};
    dd.renderContents=function(){triggerSuccessUX('pdp');};
    dd.open=function(){openDrawer();};dd.close=function(){};dd.style.setProperty('visibility','hidden','important');dd.style.setProperty('pointer-events','none','important');dd.style.setProperty('opacity','0','important');dd.style.setProperty('z-index','-1','important');dd.style.setProperty('position','fixed','important');return true;}doPatch();var att=0;var iv=setInterval(function(){if(doPatch()||++att>75)clearInterval(iv);},200);}
  function interceptQuickAdd(){document.addEventListener('submit',function(e){var form=e.target;if(!form||!form.tagName||form.tagName!=='FORM')return;var action=form.getAttribute('action')||'';if(!action.includes('/cart/add'))return;var pf=form.closest('product-form');var hasSpinner=pf&&pf.querySelector('.loading__spinner');if(hasSpinner)return;e.preventDefault();e.stopImmediatePropagation();var fd=new FormData(form);var vid=fd.get('id');if(!vid)return;var btn=form.querySelector('button[type="submit"]');if(btn)btn.style.opacity='0.5';var lwItem={id:parseInt(vid),quantity:1};var lwRegP=fd.get('properties[_reg]');if(lwRegP){lwItem.properties={_reg:lwRegP};}fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[lwItem]}),credentials:'same-origin'}).then(function(r){return r.json();}).then(function(){if(btn)btn.style.opacity='1';triggerSuccessUX('quick-add');}).catch(function(){if(btn)btn.style.opacity='1';});},true);}
  function init(){qa('.lw-drawer__close').forEach(function(b){b.addEventListener('click',closeDrawer);});var ov=qs('#lw-drawer-overlay');if(ov)ov.addEventListener('click',closeDrawer);document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});var cl=qs('#cart-icon-bubble');if(cl){cl.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();openDrawer();});}
    document.addEventListener('click',function(e){
      var bub=e.target.closest('#cart-icon-bubble, cart-icon-bubble, .header__icon--cart');
      if(bub&&!e.target.closest('#lw-cart-drawer')){e.preventDefault();e.stopPropagation();openDrawer();}
    });
    var nt=qs('#lw-note-btn');if(nt){nt.addEventListener('click',function(){nt.classList.toggle('is-open');var na=qs('#lw-note-box');if(na)na.classList.toggle('is-open');});}/* ⚠️ HIER STAND DAS SICHERN DER BESTELLNOTIZ, EIN EINZEILER AUF blur
     (geloescht am 09.09.2026). Er hat abgeschickt und weggeschaut: kein
     .then, kein .catch, keine Rueckmeldung - schlug er fehl, hielt der
     Kunde seine Notiz trotzdem fuer angekommen. Und er feuerte erst beim
     Verlassen des Feldes, also im selben Augenblick, in dem ein Klick auf
     den Kasse-Knopf die Seite wechselt: die Anfrage wurde mitten im Flug
     abgeschnitten.
     Das Sichern steht jetzt an EINER Stelle, in snippets/lw-cart-drawer.liquid
     ("DIE BESTELLNOTIZ WIRD WIRKLICH GESICHERT"), samt Rueckmeldung an den
     Kunden und einer Sperre, die den Kasse-Knopf warten laesst. Zwei
     Schreiber auf demselben Feld waeren zwei Regeln fuer dieselbe Sache. */
    document.addEventListener('click',function(e){var a=e.target;while(a&&a.tagName!=='A')a=a.parentElement;if(!a)return;var h=a.getAttribute('href')||'';if((h==='/cart'||h.endsWith('/cart'))&&!e.ctrlKey&&!e.metaKey){e.preventDefault();e.stopImmediatePropagation();openDrawer();}},true);patchDawn();interceptQuickAdd();fetchCart().then(renderAll).catch(function(e){console.warn('[LW Cart v27] init fetch error:',e);});}
  window.LWCartDrawer={open:openDrawer,close:closeDrawer,refresh:function(){return fetchCart().then(renderAll);},getLampCount:getLampCount};
  (function(){
    var origFetch=window.fetch;
    window.fetch=function(){
      var url=(typeof arguments[0]==='string')?arguments[0]:((arguments[0]&&arguments[0].url)||'');
      var result=origFetch.apply(this,arguments);
      if(url.indexOf('/cart/add')!==-1){
        result.then(function(resp){
          /* Round 13: nur 1 Refresh statt 3 — verhindert sichtbares 3x-Springen
             beim Quick-Add im Cart-Drawer. Shopify-Konsistenz <500ms */
          setTimeout(function(){fetchCart().then(function(){renderAll();}).catch(function(){});},400);
          return resp;
        }).catch(function(){});
      }
      return result;
    };
  })();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();